import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  ViewChild,
  ViewContainerRef,
  ChangeDetectorRef,
} from "@angular/core";
import { getACLicenseStatus, GetUserPermissionList } from "./../../state/index";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Store } from "@ngrx/store";
import { State } from "src/app/state/app.state";
import { ReportService } from "../shared/services/report.service";
import { ReportCommonService } from "../shared/services/report-common.service";
import {
  FiltersOptionsModel,
  PermissionGroupFilterOption,
  UserFilterOption,
  ViewFilterOption,
} from "../shared/models/filter-options-model";
import { TextBoxComponent } from "@progress/kendo-angular-inputs";
import { WindowRef, DialogService } from "@progress/kendo-angular-dialog";
import { FilterTemplateResponseModel } from "../shared/models/filter-template.response.model";
import { TranslateService } from "@ngx-translate/core";
import { ToastService } from "src/app/shared/services/toast.service";
import { Observable, forkJoin } from "rxjs";
import { UserService } from "src/app/admin/user/shared/services/user.service";

@Component({
  selector: "app-filters",
  templateUrl: "./filters.component.html",
  styleUrls: ["./filters.component.scss"],
})
export class FiltersComponent implements OnInit, OnDestroy {
  @Input() showViewFilters: boolean = true;
  /**
   * Possible values: 1, 2
   * 1 Lobby Activity
   * 2 Lobby Editor
   */
  @Input() detailViewId: number = 1;

  public hasSharedTemplatePermission: boolean = true;
  public hasDeleteTemplatePermission: boolean = false;
  public hasViewSignInOutReportPermission: boolean = false;
  public filtersForm: FormGroup = <FormGroup>{};
  public currenttemplate: any;
  public currentOptions?: FiltersOptionsModel;
  /**
   * @deprecated This is not accurate and should not be used in any new code.
   * The form state should be used instead.
   */
  public dirty: boolean = false;
  public templateSaveImplemented: boolean = false;
  public applyTooltipText: string = "";
  public formValid: boolean = true;
  public editableTemplates: boolean = true;
  public editBarVisible: boolean = false;
  public kText?: TextBoxComponent;
  public originalTemplateIsDefault: boolean = false;
  public orginalTemplateName: string = "";
  public entryTemplateName: string = "";
  public defaultHasChanged: boolean = false;
  public differentTemplateThanEntry: boolean = false;
  public isDefaultDisabled: boolean = true;
  public sharedUsers: UserFilterOption[] = [];
  public sharedPermissionGroups: PermissionGroupFilterOption[] = [];
  public showResetDialog: boolean = false;
  public showSaveAsDialog: boolean = false;
  public showSaveDialog: boolean = false;
  public showDeleteDialog: boolean = false;
  public showShareDialog: boolean = false;
  public filteredDefaultViews: ViewFilterOption[] = [];
  public isACLicenseEnabled$: Observable<boolean> = new Observable<boolean>();
  private closedByApplyOrSave: boolean = false;
  private originalOptionsSnapshot: any = null;
  private originalTemplatesSnapshot: any = null;
  private templatesSnapshot: any = null;
  private openingTemplateName: string = "";
  private lastServiceSingleSelectAt: number = 0;
  private lastServiceSingleSelectId: any = null;
  private serviceClearAllArmed: boolean = false;
  private serviceSingleSelectAfterClearAt: number = 0;
  private serviceSelectionAfterClear: any[] = [];
  private supervisorClearAllArmed: boolean = false;
  private supervisorSingleSelectAfterClearAt: number = 0;
  private supervisorSelectionAfterClear: any[] = [];

  constructor(
    public reportService: ReportService,
    public fb: FormBuilder,
    public commonData: ReportCommonService,
    public window: WindowRef,
    //public dialog: DialogRef
    private translateService: TranslateService,
    private store: Store<State>,
    public dialogService: DialogService,
    public toastService: ToastService,
    private userService: UserService,
    private cdr: ChangeDetectorRef
  ) {
    this.defaultHasChanged = false;
    this.generateFiltersForm();
  }

  @ViewChild("container", { read: ViewContainerRef })
  public containerRef?: ViewContainerRef;

  @ViewChild("locationDropdownRef") locationDropdownRef?: any;
  @ViewChild("requestedStaffDropdownRef") requestedStaffDropdownRef?: any;
  @ViewChild("supervisorDropdownRef") supervisorDropdownRef?: any;
  @ViewChild("assistedByDropdownRef") assistedByDropdownRef?: any;
  @ViewChild("categoryDropdownRef") categoryDropdownRef?: any;
  @ViewChild("serviceDropdownRef") serviceDropdownRef?: any;
  @ViewChild("usersDropdownRef") usersDropdownRef?: any;
  public viewsLocalizedKeys: Record<number, string> = {
    1: "_Report_View_Location_Comparison_Text_",
    2: "_Report_View_Traffic_And_Wait_Time_Text_",
    3: "_General_Products_Services_Text_",
    4: "_Report_View_Employee_Text_",
    5: "_Report_View_Details_Text_",
    6: "_Report_View_Staff_Signed_In_Out_Text_",
  };

  ngOnInit() {
    this.originalOptionsSnapshot = structuredClone(this.commonData.options);
    this.originalTemplatesSnapshot = structuredClone(this.commonData.originalTemplates);
    this.templatesSnapshot = structuredClone(this.commonData.templates);
    this.openingTemplateName = this.commonData.currentTemplate?.templateName || "";
    this.dirty = false;
    this.setApplyTooltipText(true, false);
    this.isACLicenseEnabled$ = this.store.select(getACLicenseStatus);
    this.store.select(GetUserPermissionList).subscribe((allUserPermissions) => {
      if (allUserPermissions) {
        this.hasSharedTemplatePermission =
          (this.detailViewId == 1 && allUserPermissions?.includes(87)) ||
          (this.detailViewId == 2 && allUserPermissions?.includes(88));
        this.hasDeleteTemplatePermission =
          (this.detailViewId === 1 && allUserPermissions?.includes(89)) ||
          (this.detailViewId === 2 && allUserPermissions?.includes(90));
        this.hasViewSignInOutReportPermission =
          allUserPermissions?.includes(91);
        // When Sign In/Out section is hidden (Lobby Activity without permission 91),
        // do not require signedInUsersDropdown so Apply is not greyed out when it is cleared.
        if (this.detailViewId === 1) {
          if (!this.hasViewSignInOutReportPermission) {
            this.filtersForm.controls["signedInUsersDropdown"].clearValidators();
          } else {
            this.filtersForm.controls["signedInUsersDropdown"].setValidators([
              Validators.minLength(1),
              Validators.required,
            ]);
          }
          this.filtersForm.controls["signedInUsersDropdown"].updateValueAndValidity();
        }
      }
    });
    if (this.detailViewId == 1) {
      this.filtersForm.controls["viewDropdown"].setValidators([
        Validators.required,
      ]);
      this.filtersForm.controls["viewDropdown"].updateValueAndValidity();
    }
    // Lobby Editor (detailViewId === 2): Sign In/Out users dropdown is hidden;
    // do not require it for form validity so Apply is not greyed out when
    // locations change and that control is cleared (e.g. async user load or no users).
    if (this.detailViewId === 2) {
      this.filtersForm.controls["signedInUsersDropdown"].clearValidators();
      this.filtersForm.controls["signedInUsersDropdown"].updateValueAndValidity();
    }

    this.commonData.options.requestedStaff.forEach((staff) => {
      if (staff.staffId === -1) {
        staff.localizedStaffFullname = this.translateService.instant(
          "_Report_Filter_NoStaff_Requested_Text_"
        );
      } else {
        staff.localizedStaffFullname = staff.staffFullname;
      }
    });

    this.commonData.options.selectedRequestedStaff.forEach((staff) => {
      if (staff.staffId === -1) {
        staff.localizedStaffFullname = this.translateService.instant(
          "_Report_Filter_NoStaff_Requested_Text_"
        );
      } else {
        staff.localizedStaffFullname = staff.staffFullname;
      }
    });

    this.commonData.options.supervisors.forEach((supervisor) => {
      if (supervisor.staffId === -1) {
        supervisor.localizedStaffFullname = this.translateService.instant(
          "_Report_Filter_NonSupervisory_Staff_Text_"
        );
      } else {
        supervisor.localizedStaffFullname = supervisor.staffFullname;
      }
    });

    this.commonData.options.selectedSupervisors.forEach((supervisor) => {
      if (supervisor.staffId === -1) {
        supervisor.localizedStaffFullname = this.translateService.instant(
          "_Report_Filter_NonSupervisory_Staff_Text_"
        );
      } else {
        supervisor.localizedStaffFullname = supervisor.staffFullname;
      }
    });

    // Filter statuses based on isACLicenseEnabled$
    this.isACLicenseEnabled$.subscribe((isEnabled) => {
      this.commonData.options.statuses =
        this.commonData.options.statuses.filter((status) => {
          if (status.lobbyStatusId === 7) {
            return isEnabled;
          }
          return true;
        });
    });

    var statusesLocalizationKeys: Record<number, string> = {
      5: "_General_Completed_Text_",
      6: "_General_LWA_Text_",
      7: "_General_No_Show_Text_",
    };

    this.commonData.options.statuses.forEach((status) => {
      if (statusesLocalizationKeys.hasOwnProperty(status.lobbyStatusId)) {
        status.localizedStatusName = this.translateService.instant(
          statusesLocalizationKeys[status.lobbyStatusId]
        );
      }
    });

    this.commonData.options.selectedStatuses.forEach((status) => {
      if (statusesLocalizationKeys.hasOwnProperty(status.lobbyStatusId)) {
        status.localizedStatusName = this.translateService.instant(
          statusesLocalizationKeys[status.lobbyStatusId]
        );
      }
    });

    this.commonData.options.autoWrapUpStatus.forEach((awStatus) => {
      const id = Number(awStatus.autoWrapUpStatusId);
      if (id === -1) {
        awStatus.localizedAutoWrapUpStatus = this.translateService.instant(
          "_Report_Filter_Show_All_Text_"
        );
      } else if (id === 0) {
        awStatus.localizedAutoWrapUpStatus = this.translateService.instant(
          "_Report_Filter_Exclude_Text_"
        );
      } else if (id === 1) {
        awStatus.localizedAutoWrapUpStatus = this.translateService.instant(
          "_Report_Filter_Show_Only_Text_"
        );
      } else {
        awStatus.localizedAutoWrapUpStatus = awStatus.autoWrapUpStatus;
      }
      awStatus.autoWrapUpStatus = awStatus.localizedAutoWrapUpStatus ?? awStatus.autoWrapUpStatus;
    });

    this.commonData.options.selectedAutoWrapUpStatus.forEach((awStatus) => {
      const id = Number(awStatus.autoWrapUpStatusId);
      if (id === -1) {
        awStatus.localizedAutoWrapUpStatus = this.translateService.instant(
          "_Report_Filter_Show_All_Text_"
        );
      } else if (id === 0) {
        awStatus.localizedAutoWrapUpStatus = this.translateService.instant(
          "_Report_Filter_Exclude_Text_"
        );
      } else if (id === 1) {
        awStatus.localizedAutoWrapUpStatus = this.translateService.instant(
          "_Report_Filter_Show_Only_Text_"
        );
      } else {
        awStatus.localizedAutoWrapUpStatus = awStatus.autoWrapUpStatus;
      }
      awStatus.autoWrapUpStatus = awStatus.localizedAutoWrapUpStatus ?? awStatus.autoWrapUpStatus;
    });

    var assistTypesLocalizationKeys: Record<number, string> = {
      1: "_Lobby_Standard_Ts_Text_",
      2: "_Report_Filter_Instant_Text_",
    };

    this.commonData.options.assistTypes.forEach((type) => {
      if (assistTypesLocalizationKeys.hasOwnProperty(type.assistTypeId)) {
        type.localizedAssistTypeName = this.translateService.instant(
          assistTypesLocalizationKeys[type.assistTypeId]
        );
      }
    });

    this.commonData.options.selectedAssistTypes.forEach((type) => {
      if (assistTypesLocalizationKeys.hasOwnProperty(type.assistTypeId)) {
        type.localizedAssistTypeName = this.translateService.instant(
          assistTypesLocalizationKeys[type.assistTypeId]
        );
      }
    });

    if (this.showViewFilters) {
      this.commonData.options.defaultViews.forEach((view) => {
        if (view.viewLocalizedName) {
          view.viewLocalizedName = this.translateService.instant(
            view.viewLocalizedName
          );
        }
      });
    }

    var daysOfWeekLocalizationKeys: Record<number, string> = {
      1: "_User_Sunday_Ts_Text_",
      2: "_User_Monday_Ts_Text_",
      3: "_User_Tuesday_Ts_Text_",
      4: "_User_Wednesday_Ts_Text_",
      5: "_User_Thursday_Ts_Text_",
      6: "_User_Friday_Ts_Text_",
      7: "_User_Saturday_Ts_Text_",
    };

    this.commonData.options.daysOfWeek.forEach((day) => {
      if (daysOfWeekLocalizationKeys.hasOwnProperty(day.dayOfWeek)) {
        day.localizedDayOfWeekName = this.translateService.instant(
          daysOfWeekLocalizationKeys[day.dayOfWeek]
        );
      }
    });

    this.commonData.options.selectedDaysOfWeek.forEach((day) => {
      if (daysOfWeekLocalizationKeys.hasOwnProperty(day.dayOfWeek)) {
        day.localizedDayOfWeekName = this.translateService.instant(
          daysOfWeekLocalizationKeys[day.dayOfWeek]
        );
      }
    });

    // Had to force change detection by updating the array reference
    this.commonData.options.requestedStaff = [
      ...this.commonData.options.requestedStaff,
    ];
    this.commonData.options.selectedRequestedStaff = [
      ...this.commonData.options.selectedRequestedStaff,
    ];
    this.commonData.options.supervisors = [
      ...this.commonData.options.supervisors,
    ];
    this.commonData.options.selectedSupervisors = [
      ...this.commonData.options.selectedSupervisors,
    ];
    this.commonData.options.statuses = [...this.commonData.options.statuses];
    this.commonData.options.selectedStatuses = [
      ...this.commonData.options.selectedStatuses,
    ];
    this.commonData.options.autoWrapUpStatus = [
      ...this.commonData.options.autoWrapUpStatus,
    ];
    this.commonData.options.selectedAutoWrapUpStatus =
      this.commonData.options.selectedAutoWrapUpStatus;
    this.commonData.options.assistTypes = [
      ...this.commonData.options.assistTypes,
    ];
    this.commonData.options.selectedAssistTypes = [
      ...this.commonData.options.selectedAssistTypes,
    ];

    if (this.showViewFilters) {
      this.commonData.options.defaultViews = [
        ...this.commonData.options.defaultViews,
      ];
    }

    this.commonData.options.daysOfWeek = [
      ...this.commonData.options.daysOfWeek,
    ];
    this.commonData.options.selectedDaysOfWeek = [
      ...this.commonData.options.selectedDaysOfWeek,
    ];

    this.enableDefaultCheckboxes();
  }

  ngAfterViewInit() {
    if (this.window) this.window.window.instance.resizable = false;
    this.setActiveTemplateOnUI(this.commonData.currentTemplate.templateName);
    this.commonData.filterServicesByCategory();
    this.commonData.filterAssistedByStaffBySupervisor(
      null,
      this.commonData.currentTemplate.allSupervisors
    );
    this.filteredDefaultViews = this.commonData.options.defaultViews.filter(
      (option) => option.viewId !== 6 || this.hasViewSignInOutReportPermission
    );
    this.originalTemplateIsDefault = this.commonData.currentTemplate.isDefault;
    var sharedOptions = this.commonData.mapSharedOptionData();
    this.sharedUsers = sharedOptions.users;
    this.sharedPermissionGroups = sharedOptions.groups;
    this.orginalTemplateName = this.commonData.currentTemplate.templateName;
    this.entryTemplateName = this.commonData.currentTemplate.templateName;
    this.differentTemplateThanEntry = false;
    this.commonData.ConvertCurrentTemplateToOptions(this.detailViewId);
    this.commonData.EnrichSelectedOptions();
    this.setFormSelectionsFromOptions();
    this.commonData.emitScrollRequest();
    this.commonData.options.selectedViews.forEach((view) => {
      if (this.viewsLocalizedKeys.hasOwnProperty(view.viewId)) {
        view.viewLocalizedName = this.translateService.instant(
          this.viewsLocalizedKeys[view.viewId]
        );
      }
    });
    this.commonData.options.selectedViews = [
      ...this.commonData.options.selectedViews,
    ];
  }

  //#region Filter Options PopUp Actions

  public showSaveAs(): void {
    this.showSaveAsDialog = true;
  }

  public SaveAsTemplateClicked(templateName: string) {
    var newTemplate = this.commonData.ConvertSelectedOptionsToTemplate(
      this.filtersForm.value,
      this.detailViewId
    );
    newTemplate.templateName = templateName;
    newTemplate.detailViewId = this.detailViewId;
    newTemplate.sharedUsers = "";
    newTemplate.sharedPermissionGroups = "";
    if (newTemplate.isDefault) {
      var oldDefaultTemplate = this.commonData.AdjustDefaults(
        newTemplate,
        this.commonData.templates
      );
      if (oldDefaultTemplate) {
        this.commonData.ReplaceTemplateWith(
          oldDefaultTemplate.templateName,
          oldDefaultTemplate,
          this.commonData.templates
        );
      }
    }
    // Do the save here
    this.filtersForm.get("editListDropdown")?.disable({ onlySelf: true });
    const saveTemplateSubscription = this.reportService
      .saveDetailsViewTemplate(newTemplate)
      .subscribe(
        (response: FilterTemplateResponseModel) => {
          // After save succeeds:
          saveTemplateSubscription.unsubscribe();
          this.commonData.AddTemplate(response);
          // In the backend, the template off of which this new template was made was automatically adjusted to unset the isDefault flag if the new template isDefault is set.
          // Therefore to maintain parity with the database we must update the original template in originalTemplates to reflect the change
          oldDefaultTemplate = this.commonData.AdjustDefaults(
            response,
            this.commonData.originalTemplates
          );
          if (oldDefaultTemplate) {
            this.commonData.ReplaceTemplateWith(
              oldDefaultTemplate.templateName,
              oldDefaultTemplate,
              this.commonData.originalTemplates
            );
          }
          this.commonData.SetActiveTemplate(response.templateName);
          this.setActiveTemplateOnUI(response.templateName);
          this.originalTemplateIsDefault =
            this.commonData.currentTemplate.isDefault;
          this.orginalTemplateName =
            this.commonData.currentTemplate.templateName;
          this.commonData.currentTemplate.templateId = response.templateId;
          this.commonData.RemoveTemplate("Custom");
          this.toastService.showSuccess(
            "_Report_Filter_Template_Creation_Success_Message_"
          );
        },
        (error) => {
          saveTemplateSubscription.unsubscribe();
          this.toastService.showError(
            "_Report_Filter_Template_Creation_Failed_Message_"
          );
        }
      );
    this.showSaveAsDialog = false;
    this.filtersForm.get("editListDropdown")?.enable({ onlySelf: true });
  }
  public SaveAsTemplateCancelClicked() {
    this.formValid = true;
    this.showSaveAsDialog = false;
  }

  public showSave(): void {
    this.showSaveDialog = true;
  }
  public SaveTemplateClicked(templateName: string) {
    var existingTemplate = this.commonData.currentTemplate;
    var newTemplate = this.commonData.ConvertSelectedOptionsToTemplate(
      this.filtersForm.value,
      this.detailViewId
    );
    newTemplate.templateName = templateName;
    newTemplate.templateId = this.commonData.currentTemplate.templateId;
    newTemplate.detailViewId = this.detailViewId;
    if (this.hasSharedTemplatePermission == true) {
      newTemplate.sharedUsers = this.sharedUsers
        .map((user) => user.staffId)
        .join(",");
      newTemplate.sharedPermissionGroups = this.sharedPermissionGroups
        .map((group) => group.permissionGroupId)
        .join(",");
    } else {
      newTemplate.sharedUsers = existingTemplate.sharedUsers;
      newTemplate.sharedPermissionGroups =
        existingTemplate.sharedPermissionGroups;
    }
    if (newTemplate.isDefault) {
      var oldDefaultTemplate = this.commonData.AdjustDefaults(
        newTemplate,
        this.commonData.templates
      );
      if (oldDefaultTemplate) {
        this.commonData.ReplaceTemplateWith(
          oldDefaultTemplate.templateName,
          oldDefaultTemplate,
          this.commonData.templates
        );
      }
    }
    // Do the save here
    this.filtersForm.get("editListDropdown")?.disable({ onlySelf: true });
    const saveTemplateSubscription = this.reportService
      .saveDetailsViewTemplate(newTemplate)
      .subscribe(
        (response: FilterTemplateResponseModel) => {
          // After save succeeds:
          saveTemplateSubscription.unsubscribe();
          // In the backend, the template off of which this new template was made was automatically adjusted to unset the isDefault flag if the new template isDefault is set.
          // Therefore to maintain parity with the database we must update the original template in originalTemplates to reflect the change
          oldDefaultTemplate = this.commonData.AdjustDefaults(
            newTemplate,
            this.commonData.originalTemplates
          );
          if (oldDefaultTemplate) {
            this.commonData.ReplaceTemplateWith(
              oldDefaultTemplate.templateName,
              oldDefaultTemplate,
              this.commonData.originalTemplates
            );
          }
          this.commonData.currentTemplate.templateId = response.templateId;
          this.commonData.ReplaceTemplateWith(
            existingTemplate.templateName,
            newTemplate,
            this.commonData.templates
          );
          this.commonData.ReplaceTemplateWith(
            existingTemplate.templateName,
            newTemplate,
            this.commonData.originalTemplates
          );
          this.editingTemplateChanged(null);
          this.setActiveTemplateOnUI(newTemplate.templateName);
          this.toastService.showSuccess(
            "_General_Changes_Saved_Successfully_Ts_Text_"
          );
        },
        (error) => {
          saveTemplateSubscription.unsubscribe();
          this.toastService.showError("_General_Saving_Failed_Ts_Text_");
        }
      );
    this.showSaveDialog = false;
    this.filtersForm.get("editListDropdown")?.enable({ onlySelf: true });
  }
  public SaveTemplateCancelClicked() {
    this.formValid = true;
    this.showSaveDialog = false;
  }

  public showDelete(): void {
    this.showDeleteDialog = true;
  }
  public DeleteTemplateYesClicked() {
    var deleteName = this.commonData.currentTemplate.templateName;
    // Do the delete here
    if (deleteName !== "Custom") {
      this.filtersForm.get("editListDropdown")?.disable({ onlySelf: true });
      const deleteTemplateSubscription = this.reportService
        .deleteDetailsViewTemplate(this.commonData.currentTemplate.templateId)
        .subscribe(
          (response) => {
            // After delete succeeds:
            if (response == true) {
              deleteTemplateSubscription.unsubscribe();
              this.commonData.RemoveTemplate(deleteName);

              var defaultTemplate = this.commonData.GetDefaultTemplate(
                this.commonData.templates
              );
              if (defaultTemplate) {
                this.commonData.SetActiveTemplate(defaultTemplate.templateName);
                this.setActiveTemplateOnUI(defaultTemplate.templateName);
              } else {
                this.commonData.SetActiveTemplate("None");
                this.setActiveTemplateOnUI("None");
              }
              this.originalTemplateIsDefault =
                this.commonData.currentTemplate.isDefault;
              this.orginalTemplateName =
                this.commonData.currentTemplate.templateName;
              this.apply(null, false);

              this.toastService.showSuccess(
                "_Report_Filter_Template_Deletion_Success_Message_"
              );
            } else {
              this.commonData.SetActiveTemplate(this.entryTemplateName);
              this.setActiveTemplateOnUI(this.entryTemplateName);
              this.toastService.showError(
                "_Report_Filter_Template_Deletion_Failed_Message_"
              );
            }
          },
          (error) => {
            deleteTemplateSubscription.unsubscribe();
            this.toastService.showError(
              "_Report_Filter_Template_Deletion_Failed_Message_"
            );
          }
        );
      this.filtersForm.get("editListDropdown")?.enable({ onlySelf: true });
    } else {
      this.commonData.RemoveTemplate(deleteName);
      var defaultTemplate = this.commonData.GetDefaultTemplate(
        this.commonData.templates
      );
      if (defaultTemplate) {
        this.commonData.SetActiveTemplate(defaultTemplate.templateName);
        this.setActiveTemplateOnUI(defaultTemplate.templateName);
      } else {
        this.commonData.SetActiveTemplate("None");
        this.setActiveTemplateOnUI("None");
      }
      this.originalTemplateIsDefault =
        this.commonData.currentTemplate.isDefault;
      this.orginalTemplateName = this.commonData.currentTemplate.templateName;
      this.toastService.showSuccess(
        "_Report_Filter_Template_Deletion_Success_Message_"
      );
      this.apply(null, false);
    }
    this.showDeleteDialog = false;
  }
  public DeleteTemplateCancelClicked() {
    this.formValid = true;
    this.showDeleteDialog = false;
  }

  public generateFiltersForm() {
    this.filtersForm = this.fb.group({
      editListDropdown: [[], Validators.minLength(1)],
      locationDropdown: [[], [Validators.minLength(1), Validators.required]],
      timePeriodDropdown: [[], Validators.minLength(1)],
      dayOfWeekDropdown: [[], [Validators.minLength(1), Validators.required]],
      userRequestedDropdown: [
        [],
        [Validators.minLength(1), Validators.required],
      ],
      assistedByDropdown: [[], [Validators.minLength(1), Validators.required]],
      supervisorDropdown: [[], [Validators.minLength(1), Validators.required]],
      categoryDropdown: [[], [Validators.minLength(1), Validators.required]],
      serviceDropdown: [[], [Validators.minLength(1), Validators.required]],
      statusDropdown: [[], [Validators.minLength(1), Validators.required]],
      assistTypeDropdown: [[], [Validators.minLength(1), Validators.required]],
      viewDropdown: [[], Validators.minLength(1)],
      autoWrapUpStatusDropdown: [
        [],
        [Validators.minLength(1), Validators.required],
      ],
      isDefault: [""],
      search: [""], //this.commonData.currentTemplate.activeFilters['searchTerms'][0].searchTerm
      signedInUsersDropdown: [
        [],
        [Validators.minLength(1), Validators.required],
      ],
    });
  }

  public templateNameChanged() {}
  public cancel() {
    this.pendingLocationSelectAllMerge = null;
    this.restorePopupStateOnCloseWithoutCommit();
    this.commonData.filtersClosed();
    this.window.close();
  }

  private restorePopupStateOnCloseWithoutCommit(): void {
    try {
      if (this.originalOptionsSnapshot) {
        Object.assign(
          this.commonData.options,
          structuredClone(this.originalOptionsSnapshot)
        );
      }

      if (this.originalTemplatesSnapshot) {
        this.commonData.originalTemplates = structuredClone(
          this.originalTemplatesSnapshot
        );
      }

      if (this.templatesSnapshot) {
        this.commonData.templates = structuredClone(this.templatesSnapshot);
      }

      const targetTemplateName =
        this.openingTemplateName || this.entryTemplateName || "None";
      this.commonData.SetActiveTemplate(targetTemplateName);
    } catch (e) {
    }
  }

  showReset(): void {
    this.showResetDialog = true;
  }

  public closeResetDialog() {
    this.showResetDialog = false;
  }

  public reset() {
    this.pendingLocationSelectAllMerge = null;
    this.commonData.ConvertCurrentTemplateToOptions(this.detailViewId); // reverts the options to unchanged values
    this.formValid = true;
    this.dirty = false;
    this.showResetDialog = false;

    this.filtersForm.markAsPristine();
    this.filtersForm.markAsUntouched();
    this.commonData.RemoveTemplate("Custom");
    var defaultTemplate = this.commonData.GetResetDefaultTemplate(
      this.commonData.templates,
      this.commonData.currentTemplate.templateId
    );
    if (defaultTemplate) {
      this.commonData.SetActiveTemplate(defaultTemplate.templateName);
      this.setActiveTemplateOnUI(defaultTemplate.templateName);
    } else {
      this.commonData.SetActiveTemplate("None");
      this.setActiveTemplateOnUI("None");
    }

    this.enableDefaultCheckboxes();
  }

  public apply(event: any, close: boolean = true): void {
    // Normally event comes in as null
    // The exception is when we call apply() directly from the delete routine after finding no default
    // template to auto-apply. In that case we apply the unfiltered template.
    // Normally we want to create a Unsaved(Custom) filter set and apply it. But not in the above corner case.
    if (
      this.commonData.currentTemplate.templateName != "None" ||
      event != null
    ) {
      const isUserApply = event != null;
      const applyFormData = {
        ...this.filtersForm.value,
        locationDropdown: [...(this.commonData.options.selectedLocations || [])],
        timePeriodDropdown: [...(this.commonData.options.selectedTimePeriod || [])],
        dayOfWeekDropdown: [...(this.commonData.options.selectedDaysOfWeek || [])],
        userRequestedDropdown: [...(this.commonData.options.selectedRequestedStaff || [])],
        assistedByDropdown: [...(this.commonData.options.selectedAssistedBys || [])],
        supervisorDropdown: [...(this.commonData.options.selectedSupervisors || [])],
        categoryDropdown: [...(this.commonData.options.selectedCategories || [])],
        serviceDropdown: [...(this.commonData.options.selectedServices || [])],
        statusDropdown: [...(this.commonData.options.selectedStatuses || [])],
        assistTypeDropdown: [...(this.commonData.options.selectedAssistTypes || [])],
        viewDropdown: [...(this.commonData.options.selectedViews || [])],
        autoWrapUpStatusDropdown: [...(this.commonData.options.selectedAutoWrapUpStatus || [])],
        signedInUsersDropdown: [...(this.commonData.options.selectedUsers || [])],
      };

      var newTemplate = isUserApply
        ? this.commonData.ConvertSelectedOptionsToTemplate(
            applyFormData,
            this.detailViewId
          )
        : this.commonData.currentTemplate;

      newTemplate.detailViewId = this.detailViewId;

      if (isUserApply) {
        const allLocations = this.commonData.options.locations || [];
        const selectedLocations = this.commonData.options.selectedLocations || [];
        const normalizedSelected = selectedLocations
          .map((sl: any) => {
            const matched = allLocations.find((l: any) =>
              (sl?.code != null && l?.code == sl.code) ||
              (sl?.locationId != null && l?.locationId == sl.locationId)
            );
            return {
              locationId: matched?.locationId ?? sl?.locationId,
              code: matched?.code ?? sl?.code,
              locationName: matched?.locationName ?? sl?.locationName,
            };
          })
          .filter((l: any) => l?.code != null || l?.locationId != null);

        if (!newTemplate.activeFilters) {
          newTemplate.activeFilters = new FiltersOptionsModel();
        }

        newTemplate.allLocations =
          allLocations.length > 0 &&
          normalizedSelected.length === allLocations.length;
        newTemplate.activeFilters.locations = newTemplate.allLocations
          ? []
          : normalizedSelected;
      }

      if (!isUserApply && this.commonData.currentTemplate.templateName != "Custom") {
        this.commonData.SetActiveTemplate(
          this.commonData.currentTemplate.templateName
        );
      } else {
        newTemplate.templateName = "Custom";
        newTemplate.templateId = -1;
        newTemplate.isDefault = false;
        newTemplate.sharedUsers = "";
        newTemplate.sharedPermissionGroups = "";
        if (this.commonData.TemplateExists("Custom")) {
          this.commonData.ReplaceTemplateWith(
            "Custom",
            newTemplate,
            this.commonData.templates
          );
          this.commonData.ReplaceTemplateWith(
            "Custom",
            newTemplate,
            this.commonData.originalTemplates
          );
        } else {
          this.commonData.AddTemplate(newTemplate);
        }
        this.commonData.SetActiveTemplate(newTemplate.templateName);
      }
    }
    this.commonData.applyOptions(this.detailViewId);
    if (close) {
      this.closedByApplyOrSave = true;
      this.window.close();
    }
  }

  ngOnDestroy(): void {
    this.pendingLocationSelectAllMerge = null;
    if (!this.closedByApplyOrSave) {
      try {
        this.restorePopupStateOnCloseWithoutCommit();
        if (this.commonData?.filtersClosed) {
          this.commonData.filtersClosed();
        }
      } catch (e) {
      }
    }
  }

  public showShare(): void {
    this.showShareDialog = true;
  }

  public ShareTemplateClicked(event: any) {
    var existingTemplate = this.commonData.currentTemplate;
    var newTemplate = structuredClone(existingTemplate);
    newTemplate.sharedUsers = event.sharedUsers
      .map((user: UserFilterOption) => user.staffId)
      .join(",");
    newTemplate.sharedPermissionGroups = event.sharedPermissionGroups
      .map((group: PermissionGroupFilterOption) => group.permissionGroupId)
      .join(",");
    if (newTemplate.isDefault) {
      var oldDefaultTemplate = this.commonData.AdjustDefaults(
        newTemplate,
        this.commonData.templates
      );
      if (oldDefaultTemplate) {
        this.commonData.ReplaceTemplateWith(
          oldDefaultTemplate.templateName,
          oldDefaultTemplate,
          this.commonData.templates
        );
      }
    }
    this.filtersForm.get("editListDropdown")?.disable({ onlySelf: true });
    const shareTemplateSubscription = this.reportService
      .saveDetailsViewTemplate(newTemplate)
      .subscribe(
        (response: FilterTemplateResponseModel) => {
          // After save succeeds:
          shareTemplateSubscription.unsubscribe();
          // In the backend, the template off of which this new template was made was automatically adjusted to unset the isDefault flag if the new template isDefault is set.
          // Therefore to maintain parity with the database we must update the original template in originalTemplates to reflect the change
          oldDefaultTemplate = this.commonData.AdjustDefaults(
            newTemplate,
            this.commonData.originalTemplates
          );
          if (oldDefaultTemplate) {
            this.commonData.ReplaceTemplateWith(
              oldDefaultTemplate.templateName,
              oldDefaultTemplate,
              this.commonData.originalTemplates
            );
          }
          this.commonData.currentTemplate.templateId = response.templateId;
          this.commonData.ReplaceTemplateWith(
            existingTemplate.templateName,
            newTemplate,
            this.commonData.templates
          );
          this.commonData.ReplaceTemplateWith(
            existingTemplate.templateName,
            newTemplate,
            this.commonData.originalTemplates
          );
          this.editingTemplateChanged(null);
          this.setActiveTemplateOnUI(newTemplate.templateName);
          this.toastService.showSuccess(
            "_Report_Filter_Template_Share_Success_Message_"
          );
        },
        (error) => {
          shareTemplateSubscription.unsubscribe();
          this.toastService.showError(
            "_Report_Filter_Template_Share_Failed_Message_"
          );
        }
      );
    this.showShareDialog = false;
  }

  public ShareTemplateCancelClicked() {
    this.showShareDialog = false;
  }

  //#endregion Filter Options PopUp Actions

  public formDataToOptions(): FiltersOptionsModel {
    return new FiltersOptionsModel();
  }

  public showEditArea() {
    this.editBarVisible = !this.editBarVisible;
    this.showSaveAs();
  }

  public onIsDefaultChange() {
    var match = this.commonData.TemplateMatchesExisting(
      this.commonData.currentTemplate,
      true,
      this.commonData.originalTemplates
    );
    this.dirty = match ? false : true;
  }

  public markAsNotChanged() {
    this.filtersForm.controls["isDefault"].markAsPristine({ onlySelf: true });
    this.filtersForm.controls["isDefault"].markAsUntouched({ onlySelf: true });
  }


  private mergeSelectAllWithExisting(
    currentSelections: any[],
    filteredItems: any[],
    idField: string
  ): any[] {
    if (!filteredItems || filteredItems.length === 0) {
      return currentSelections || [];
    }

    const mergedSet = new Map<any, any>();

    if (currentSelections && Array.isArray(currentSelections)) {
      currentSelections.forEach((item) => {
        const id = item?.[idField];
        if (id != null) {
          mergedSet.set(id, item);
        }
      });
    }

    filteredItems.forEach((item) => {
      const id = item?.[idField];
      if (id != null) {
        mergedSet.set(id, item);
      }
    });

    return Array.from(mergedSet.values());
  }

  private syncSelectAllState(
    dropdownRef: any,
    selectedItems: any[],
    idField: string
  ): void {
    if (!dropdownRef || !idField) {
      return;
    }

    const filteredItems =
      dropdownRef?.filteredList ??
      dropdownRef?._filteredList ??
      dropdownRef?.filteredData ??
      dropdownRef?.data ??
      [];
    const filteredArray = Array.isArray(filteredItems) ? filteredItems : [];
    const selectedIds = new Set(
      (selectedItems || [])
        .map((item) => item?.[idField])
        .filter((value) => value != null)
        .map((value) => value.toString())
    );
    const allFilteredSelected =
      filteredArray.length > 0 &&
      filteredArray.every((item) => {
        const id = item?.[idField];
        return id != null && selectedIds.has(id.toString());
      });

    if (dropdownRef._allSelected !== undefined) {
      dropdownRef._allSelected = allFilteredSelected;
    }
    if (dropdownRef.updateSelectedItems) {
      dropdownRef.updateSelectedItems();
    }
    if (dropdownRef.updateCheckboxLabel) {
      dropdownRef.updateCheckboxLabel();
    }
    this.cdr.markForCheck();
    this.cdr.detectChanges();
  }

  private patchSelectAllIdentityChecks(): void {
    const dropdowns = [
      this.locationDropdownRef,
      this.requestedStaffDropdownRef,
      this.supervisorDropdownRef,
      this.assistedByDropdownRef,
      this.categoryDropdownRef,
      this.serviceDropdownRef,
      this.usersDropdownRef,
    ];

    dropdowns.forEach((dropdownRef) =>
      this.applyIdentitySelectAllPatch(dropdownRef)
    );
  }

  private applyIdentitySelectAllPatch(dropdownRef: any): void {
    if (!dropdownRef || dropdownRef.__identitySelectAllPatched) {
      return;
    }

    dropdownRef.__identitySelectAllPatched = true;
    dropdownRef.isAllItemsSelected = () => {
      const data = dropdownRef._data || [];
      const filter = dropdownRef.filter || { text: "" };
      const listFilterPipe = dropdownRef.listFilterPipe;
      const filteredItems = listFilterPipe?.transform
        ? listFilterPipe.transform(data, filter)
        : data.filter((item: any) => {
            const text = item?.text?.toString().toLowerCase() ?? "";
            const term = filter?.text?.toString().toLowerCase() ?? "";
            return term ? text.indexOf(term) !== -1 : true;
          });

      if ((!dropdownRef.data || dropdownRef.data.length === 0) && dropdownRef._settings?.allowRemoteDataSearch) {
        return false;
      }
      if (!filteredItems || filteredItems.length === 0) {
        return false;
      }

      const selectedIds = new Set(
        (dropdownRef.selectedItems || []).map((item: any) => item?.id?.toString())
      );
      return filteredItems.every(
        (item: any) => item?.isDisabled || selectedIds.has(item?.id?.toString())
      );
    };
  }

  public onLocationFilterChange(): void {
    const filterText = this.locationDropdownRef?.filter?.text?.toString().toLowerCase() || "";
    const allData = this.locationDropdownRef?.data || this.commonData.options.locations || [];
    const textField = this.locationDropdownSettings.textField;
    
    const filteredItems = filterText 
      ? allData.filter((item: any) => {
          const text = item?.[textField]?.toString().toLowerCase() || "";
          return text.includes(filterText);
        })
      : allData;
    
    this.pendingLocationUnSelectData = { filterText, filteredItems };
    
    setTimeout(() =>
      this.syncSelectAllState(
        this.locationDropdownRef,
        this.commonData.options.selectedLocations,
        this.locationDropdownSettings.idField
      ),
    0);
  }

  public onRequestedStaffFilterChange(): void {
    const filterText = this.requestedStaffDropdownRef?.filter?.text?.toString().toLowerCase() || "";
    const allData = this.requestedStaffDropdownRef?.data || this.commonData.options.requestedStaff || [];
    const textField = this.userRequestedDropdownSettings.textField;
    
    const filteredItems = filterText
      ? allData.filter((item: any) => {
          const text = item?.[textField]?.toString().toLowerCase() || "";
          return text.includes(filterText);
        })
      : allData;
    
    this.pendingRequestedStaffUnSelectData = { filterText, filteredItems };
    
    setTimeout(() =>
      this.syncSelectAllState(
        this.requestedStaffDropdownRef,
        this.commonData.options.selectedRequestedStaff,
        this.userRequestedDropdownSettings.idField
      ),
    0);
  }

  public onSupervisorFilterChange(): void {
    const filterText = this.supervisorDropdownRef?.filter?.text?.toString().toLowerCase() || "";
    const allData = this.supervisorDropdownRef?.data || this.commonData.options.supervisors || [];
    const textField = this.supervisorDropdownSettings.textField;
    
    const filteredItems = filterText
      ? allData.filter((item: any) => {
          const text = item?.[textField]?.toString().toLowerCase() || "";
          return text.includes(filterText);
        })
      : allData;
    
    this.pendingSupervisorUnSelectData = { filterText, filteredItems };
    
    setTimeout(() =>
      this.syncSelectAllState(
        this.supervisorDropdownRef,
        this.commonData.options.selectedSupervisors,
        this.supervisorDropdownSettings.idField
      ),
    0);
  }

  public onAssistedByFilterChange(): void {
    const filterText = this.assistedByDropdownRef?.filter?.text?.toString().toLowerCase() || "";
    const allData = this.assistedByDropdownRef?.data || this.commonData.options.assistedBy || [];
    const textField = this.assistedByDropdownSettings.textField;
    
    const filteredItems = filterText
      ? allData.filter((item: any) => {
          const text = item?.[textField]?.toString().toLowerCase() || "";
          return text.includes(filterText);
        })
      : allData;
    
    this.pendingAssistedByUnSelectData = { filterText, filteredItems };
    
    setTimeout(() =>
      this.syncSelectAllState(
        this.assistedByDropdownRef,
        this.commonData.options.selectedAssistedBys,
        this.assistedByDropdownSettings.idField
      ),
    0);
  }

  public onCategoryFilterChange(): void {
    const filterText = this.categoryDropdownRef?.filter?.text?.toString().toLowerCase() || "";
    const allData = this.categoryDropdownRef?.data || this.commonData.options.categories || [];
    const textField = this.categoryDropdownSettings.textField;
    
    const filteredItems = filterText
      ? allData.filter((item: any) => {
          const text = item?.[textField]?.toString().toLowerCase() || "";
          return text.includes(filterText);
        })
      : allData;
    
    this.pendingCategoryUnSelectData = { filterText, filteredItems };
    
    setTimeout(() =>
      this.syncSelectAllState(
        this.categoryDropdownRef,
        this.commonData.options.selectedCategories,
        this.categoryDropdownSettings.idField
      ),
    0);
  }

  public onServiceFilterChange(): void {
    const filterText = this.serviceDropdownRef?.filter?.text?.toString().toLowerCase() || "";
    const allData = this.serviceDropdownRef?.data || this.commonData.options.services || [];
    const textField = this.serviceDropdownSettings.textField;
    
    const filteredItems = filterText
      ? allData.filter((item: any) => {
          const text = item?.[textField]?.toString().toLowerCase() || "";
          return text.includes(filterText);
        })
      : allData;
    
    this.pendingServiceUnSelectData = { filterText, filteredItems };
    
    setTimeout(() =>
      this.syncSelectAllState(
        this.serviceDropdownRef,
        this.commonData.options.selectedServices,
        this.serviceDropdownSettings.idField
      ),
    0);
  }

  public onUsersFilterChange(): void {
    const filterText = this.usersDropdownRef?.filter?.text?.toString().toLowerCase() || "";
    const allData = this.usersDropdownRef?.data || this.commonData.options.users || [];
    const textField = this.usersDropdownSettings.textField;
    
    const filteredItems = filterText
      ? allData.filter((item: any) => {
          const text = item?.[textField]?.toString().toLowerCase() || "";
          return text.includes(filterText);
        })
      : allData;
    
    this.pendingUserUnSelectData = { filterText, filteredItems };
    
    setTimeout(() =>
      this.syncSelectAllState(
        this.usersDropdownRef,
        this.commonData.options.selectedUsers,
        this.usersDropdownSettings.idField
      ),
    0);
  }

  private resolveItemsToUnselect(
    eventItems: any[] | undefined,
    pendingData: { filteredItems: any[] } | null,
    dropdownRef: any
  ): any[] {
    if (Array.isArray(eventItems) && eventItems.length > 0) {
      return eventItems;
    }

    const hasActiveSearch =
      !!dropdownRef?.filter?.text?.toString().trim().length;
    if (hasActiveSearch && pendingData?.filteredItems) {
      return pendingData.filteredItems;
    }

    return [];
  }

  public optionsDirty(
    controlBeingChangedToAllSelected: string = "",
    testForDefault: boolean = true,
    suppressTemplateActivation: boolean = false
  ) {
    this.filtersForm.markAsTouched();
    this.filtersForm.get("isDefault")?.enable({ onlySelf: true });
    if (
      !this.filtersForm.controls.assistedByDropdown.valid ||
      !this.filtersForm.controls.assistTypeDropdown.valid ||
      !this.filtersForm.controls.categoryDropdown.valid ||
      !this.filtersForm.controls.dayOfWeekDropdown.valid ||
      !this.filtersForm.controls.locationDropdown.valid ||
      !this.filtersForm.controls.serviceDropdown.valid ||
      !this.filtersForm.controls.statusDropdown.valid ||
      !this.filtersForm.controls.supervisorDropdown.valid ||
      !this.filtersForm.controls.userRequestedDropdown.valid ||
      !this.filtersForm.controls.signedInUsersDropdown.valid ||
      (!this.filtersForm.controls.isDefault.valid &&
        this.filtersForm.controls.isDefault.status != "DISABLED")
    ) {
      // if any of the controls is invalid (each has a "required" validator attached), then
      // we set to not dirty which disallows saving, applying, etc
      this.dirty = false;
      this.formValid = true;
      this.setApplyTooltipText(true, false);
    } else {
      // all controls validate ok
      // now we will create a new template from the current filters and will compare them against
      // the original unedited version of the template
      var newTemplate;
      if (this.commonData.currentTemplate.templateName == "None") {
        newTemplate = this.commonData.ConvertSelectedOptionsToTemplate(
          this.filtersForm.value,
          this.detailViewId
        );
        newTemplate.isDefault = this.filtersForm.value.isDefault;

        if (!suppressTemplateActivation) {
          if (!this.commonData.TemplateExists("Custom")) {
            this.commonData.AddTemplate(newTemplate);
          } else {
            this.commonData.ReplaceTemplateWith(
              "Custom",
              newTemplate,
              this.commonData.templates
            );
            this.commonData.ReplaceTemplateWith(
              "Custom",
              newTemplate,
              this.commonData.originalTemplates
            );
          }
          // First edit from "None" should not force a full template reload,
          // otherwise the dropdown re-renders/retracts mid-interaction.
          this.commonData.SetActiveTemplate(newTemplate.templateName);
          const editCtrl = this.filtersForm.get("editListDropdown");
          if (editCtrl && editCtrl.value !== newTemplate.templateName) {
            editCtrl.setValue(newTemplate.templateName, { emitEvent: false });
          }
        }
      } else {
        newTemplate = structuredClone(this.commonData.currentTemplate);
      }

      var match;
      // param controlBeingChangedToAllSelected comes in with the name of a control when it has been
      // set to 'select all'
      // If this happens then we reflect that into the new template
      if (controlBeingChangedToAllSelected != "") {
        switch (controlBeingChangedToAllSelected) {
          case "AssistTypes":
            newTemplate.allAssistTypes = true;
            newTemplate.activeFilters.assistTypes.length = 0;
            break;
          case "AssistedBy":
            if (
              this.commonData.options.selectedAssistedBys.length ===
              this.commonData.options.filteredAssistedBys.length
            ) {
              newTemplate.allAssistedBy = newTemplate.allSupervisors;
              if (newTemplate.allSupervisors)
                newTemplate.activeFilters.assistedBy.length = 0;
            }
            break;
          case "Categories":
            if (
              this.commonData.options.selectedCategories.length ===
              this.commonData.options.categories.length
            ) {
              newTemplate.allCategories = true;
              newTemplate.activeFilters.categories.length = 0;
              newTemplate.allServices = true;
              newTemplate.activeFilters.services.length = 0;
            }
            break;
          case "Days":
            newTemplate.allDays = true;
            newTemplate.activeFilters.daysOfWeek.length = 0;
            break;
          case "Locations":
            if (
              this.commonData.options.selectedLocations.length ===
              this.commonData.options.locations.length
            ) {
              newTemplate.allLocations = true;
              newTemplate.activeFilters.locations.length = 0;
            }
            break;
          case "RequestedStaff":
            if (
              this.commonData.options.selectedRequestedStaff.length ===
              this.commonData.options.requestedStaff.length
            ) {
              newTemplate.allRequestedStaff = true;
              newTemplate.activeFilters.requestedStaff.length = 0;
            }
            break;
          case "Services":
            if (
              this.commonData.options.selectedServices.length ===
              this.commonData.options.services.length
            ) {
              newTemplate.allServices = newTemplate.allCategories;
              if (newTemplate.allCategories)
                newTemplate.activeFilters.services.length = 0;
            }
            break;
          case "Statuses":
            newTemplate.allStatuses = true;
            newTemplate.activeFilters.statuses.length = 0;
            break;
          case "Supervisors":
            if (
              this.commonData.options.selectedSupervisors.length ===
              this.commonData.options.supervisors.length
            ) {
              newTemplate.allSupervisors = true;
              newTemplate.activeFilters.supervisors.length = 0;
              newTemplate.allAssistedBy = true;
              newTemplate.activeFilters.assistedBy.length = 0;
            }
            break;
          case "Users":
            if (
              this.commonData.options.selectedUsers.length ===
              this.commonData.options.users.length
            ) {
              newTemplate.allUsers = true;
              newTemplate.activeFilters.users.length = 0;
            }
            break;
        }
      }
      // Either the allxxxxx property or the activeFilters array of each filter must have a valid value
      // Things shold never get to this condition, given the prior checks - but this backstops any case
      // that might slip through
      if (
        (newTemplate.allAssistTypes == false &&
          !newTemplate.activeFilters.assistTypes) ||
        (newTemplate.allAssistedBy == false &&
          !newTemplate.activeFilters.assistedBy) ||
        (newTemplate.allCategories == false &&
          !newTemplate.activeFilters.categories) ||
        (newTemplate.allDays == false &&
          !newTemplate.activeFilters.daysOfWeek) ||
        (newTemplate.allLocations == false &&
          !newTemplate.activeFilters.locations) ||
        (newTemplate.allRequestedStaff == false &&
          !newTemplate.activeFilters.requestedStaff) ||
        (newTemplate.allServices == false &&
          !newTemplate.activeFilters.services) ||
        (newTemplate.allStatuses == false &&
          !newTemplate.activeFilters.statuses) ||
        (newTemplate.allSupervisors == false &&
          !newTemplate.activeFilters.supervisors) ||
        (newTemplate.allUsers == false && !newTemplate.activeFilters.users) ||
        !newTemplate.activeFilters.defaultViews ||
        !newTemplate.activeFilters.autoWrapUpStatus
      ) {
        this.dirty = false;
        this.formValid = true;
        this.setApplyTooltipText(true, false);
      } else {
        // At this point our edited template is ready to compare to its original
        if (
          (match = this.commonData.TemplateMatchesCurrent(
            newTemplate,
            testForDefault
          ))
        ) {
          // compares the same - so no dirty condition - nothing to save/apply, etc.
          this.dirty = false;
          this.formValid = true;
          this.setApplyTooltipText(true, false);
        } else {
          // Some difference exists
          this.dirty = true;
          this.formValid = false;
          this.setApplyTooltipText(false, false);
        }
      }
    }
  }

  private addCustomTemplate() {
    if (this.commonData.currentTemplate.templateName == "None") {
      var newTemplate = this.commonData.ConvertSelectedOptionsToTemplate(
        this.filtersForm.value,
        this.detailViewId
      );
      newTemplate.isDefault = this.filtersForm.value.isDefault;

      if (!this.commonData.TemplateExists("Custom")) {
        this.commonData.AddTemplate(newTemplate);
      }
      // Keep user interaction stable; do not trigger full editingTemplateChanged here.
      this.commonData.SetActiveTemplate(newTemplate.templateName);
      const editCtrl = this.filtersForm.get("editListDropdown");
      if (editCtrl && editCtrl.value !== newTemplate.templateName) {
        editCtrl.setValue(newTemplate.templateName, { emitEvent: false });
      }
    }
  }

  //#region Filter Options Configuration

  // Locations
  public locationList: any[] = [];
  private pendingLocationSelectAllMerge: { prevSelections: any[]; filteredItems: any[] } | null = null;
  private pendingLocationUnSelectData: { filterText: string; filteredItems: any[] } | null = null;
  
  private pendingRequestedStaffUnSelectData: { filterText: string; filteredItems: any[] } | null = null;
  
  private pendingAssistedByUnSelectData: { filterText: string; filteredItems: any[] } | null = null;
  
  private pendingSupervisorUnSelectData: { filterText: string; filteredItems: any[] } | null = null;
  
  private pendingCategoryUnSelectData: { filterText: string; filteredItems: any[] } | null = null;
  
  private pendingServiceUnSelectData: { filterText: string; filteredItems: any[] } | null = null;
  
  private pendingUserUnSelectData: { filterText: string; filteredItems: any[] } | null = null;
  
  public locationDropdownSettings = {
    singleSelection: false,
    idField: "code",
    textField: "locationName",
    itemsShowLimit: 3,
    noDataAvailablePlaceholderText: this.translateService.instant(
      "_Dashboard_No_Data_Available_Message_Text_"
    ),
    unSelectAllText: this.translateService.instant(
      "_General_Unselect_All_Ts_Text_"
    ),
    selectAllText: this.translateService.instant("_General_Select_All_Text_"),
    allowSearchFilter: true,
    enableCheckAll: true,
    closeDropDownOnSelection: false,
    searchPlaceholderText: this.translateService.instant(
      "_General_Search_Text_"
    ),
  };
  onLocationSelect() {
    this.optionsDirty();
    setTimeout(() => this.updateSignInOutUsersForLocations(), 0);
  }

  onLocationDeSelect() {
    this.optionsDirty();
    this.formValid = false;
    setTimeout(() => this.updateSignInOutUsersForLocations(), 0);
  }

  onSelectAllLocations(items?: any[]) {
    if (items && items.length > 0) {
      const merged = this.mergeSelectAllWithExisting(
        this.commonData.options.selectedLocations,
        items,
        this.locationDropdownSettings.idField
      );
      
      this.commonData.options.selectedLocations = merged;
      const ctrl = this.filtersForm.get("locationDropdown");
      if (ctrl) {
        ctrl.setValue(merged);
        ctrl.markAsDirty();
      }
      this.optionsDirty("Locations");
      setTimeout(() => this.updateSignInOutUsersForLocations(), 0);
      return;
    }

    this.optionsDirty("Locations");
    try {
      const all = [...(this.commonData.options.locations || [])];
      this.commonData.options.selectedLocations = all;
      const ctrl = this.filtersForm.get("locationDropdown");
      if (ctrl) ctrl.setValue(all);
    } catch (e) {
    }

    setTimeout(() => this.updateSignInOutUsersForLocations(), 0);
  }

  onDeSelectAllLocations(items?: any[]) {
    this.pendingLocationSelectAllMerge = null;
    const idField = this.locationDropdownSettings.idField;
    
    const itemsToUnselect = this.resolveItemsToUnselect(
      items,
      this.pendingLocationUnSelectData,
      this.locationDropdownRef
    );

    if (itemsToUnselect.length === 0) {
      this.commonData.options.selectedLocations = [];
      const ctrl = this.filtersForm.get("locationDropdown");
      if (ctrl) ctrl.setValue([]);
      
      this.dirty = false;
      this.formValid = false;
      this.setApplyTooltipText(false, true);
      this.pendingLocationUnSelectData = null;
      
      if (this.locationDropdownRef) {
        if ((this.locationDropdownRef as any)._allSelected !== undefined) {
          (this.locationDropdownRef as any)._allSelected = false;
        }
        if ((this.locationDropdownRef as any).updateSelectedItems) {
          (this.locationDropdownRef as any).updateSelectedItems();
        }
        if ((this.locationDropdownRef as any).updateCheckboxLabel) {
          (this.locationDropdownRef as any).updateCheckboxLabel();
        }
        this.cdr.markForCheck();
        this.cdr.detectChanges();
      }
      
      setTimeout(() => this.updateSignInOutUsersForLocations(), 50);
      this.cdr.markForCheck();
      this.cdr.detectChanges();
      return;
    }
    
    const idsToUnselect = new Set(itemsToUnselect.map((item: any) => item?.[idField]));
    
    const remaining = this.commonData.options.selectedLocations.filter(
      (item: any) => !idsToUnselect.has(item?.[idField])
    );
    
    this.commonData.options.selectedLocations = remaining;
    const ctrl = this.filtersForm.get("locationDropdown");
    if (ctrl) ctrl.setValue(remaining);
    
    if (this.locationDropdownRef) {
      if ((this.locationDropdownRef as any)._allSelected !== undefined) {
        (this.locationDropdownRef as any)._allSelected = false;
      }
      if ((this.locationDropdownRef as any).updateSelectedItems) {
        (this.locationDropdownRef as any).updateSelectedItems();
      }
      if ((this.locationDropdownRef as any).updateCheckboxLabel) {
        (this.locationDropdownRef as any).updateCheckboxLabel();
      }
      this.cdr.markForCheck();
      this.cdr.detectChanges();
      setTimeout(() => this.cdr.detectChanges(), 10);
    }
    
    this.dirty = false;
    this.formValid = false;
    this.setApplyTooltipText(false, true);
    if (remaining && remaining.length > 0) {
      this.addCustomTemplate();
    }
    this.pendingLocationUnSelectData = null;
    setTimeout(() => this.updateSignInOutUsersForLocations(), 50);
    this.cdr.markForCheck();
    this.cdr.detectChanges();
  }

  onLocationsDropdownClose() {
    if (this.pendingLocationSelectAllMerge) {
      const { prevSelections, filteredItems } = this.pendingLocationSelectAllMerge;
      const merged = this.mergeSelectAllWithExisting(
        prevSelections,
        filteredItems,
        this.locationDropdownSettings.idField
      );
      
      this.commonData.options.selectedLocations = merged;
      const ctrl = this.filtersForm.get("locationDropdown");
      if (ctrl) {
        ctrl.setValue(merged);
        ctrl.markAsDirty();
      }
      this.pendingLocationSelectAllMerge = null;
      this.cdr.markForCheck();
      this.cdr.detectChanges();
      this.updateSignInOutUsersForLocations();
    }
  }

  onRequestedStaffDropdownClose() {
    this.pendingRequestedStaffUnSelectData = null;
  }

  onSupervisorDropdownClose() {
    this.pendingSupervisorUnSelectData = null;
  }

  onAssistedByDropdownClose() {
    this.pendingAssistedByUnSelectData = null;
  }

  onCategoryDropdownClose() {
    this.pendingCategoryUnSelectData = null;
  }

  onServiceDropdownClose() {
    this.pendingServiceUnSelectData = null;
    this.serviceClearAllArmed = false;
    this.serviceSelectionAfterClear = [];
    this.serviceSingleSelectAfterClearAt = 0;
  }

  onUsersDropdownClose() {
    this.pendingUserUnSelectData = null;
  }

  // Time Periods
  public timePeriodList = [];
  public selectedtimePeriod: any[] = [];
  public timePeriodDropdownSettings = {
    singleSelection: true,
    idField: "detailViewTimePeriodId",
    textField: "timePeriodName",
  };
  onTimePeriodSelect() {
    const tp = this.commonData.options.selectedTimePeriod;
    this.commonData.options.selectedTimePeriod = Array.isArray(tp)
      ? tp
      : tp
      ? [tp]
      : [];
    this.optionsDirty();
  }

  onTimePeriodDeSelect() {
    const tp = this.commonData.options.selectedTimePeriod;
    this.commonData.options.selectedTimePeriod = Array.isArray(tp)
      ? tp
      : tp
      ? [tp]
      : [];
    this.optionsDirty();
  }

  // Days of Week
  public dayOfWeekList = [];
  public selectedDaysOfWeek: any[] = [];
  public dayOfWeekDropdownSettings = {
    singleSelection: false,
    idField: "dayOfWeek",
    textField: "localizedDayOfWeekName",
    itemsShowLimit: 3,
    unSelectAllText: this.translateService.instant(
      "_General_Unselect_All_Ts_Text_"
    ),
    selectAllText: this.translateService.instant("_General_Select_All_Text_"),
    noDataAvailablePlaceholderText: this.translateService.instant(
      "_Dashboard_No_Data_Available_Message_Text_"
    ),
  };
  onDayOfWeekSelect() {
    this.optionsDirty();
  }

  onDayOfWeekDeSelect() {
    this.optionsDirty();
  }

  onSelectAllDaysOfWeek(items?: any[]) {
    if (items && items.length > 0) {
      const merged = this.mergeSelectAllWithExisting(
        this.commonData.options.selectedDaysOfWeek,
        items,
        this.dayOfWeekDropdownSettings.idField
      );
      this.commonData.options.selectedDaysOfWeek = merged;
      const ctrl = this.filtersForm.get("dayOfWeekDropdown");
      if (ctrl) ctrl.setValue(merged);
    }
    this.optionsDirty("Days");
  }

  onDeSelectAllDaysOfWeek(items?: any[]) {
    if (items && items.length > 0) {
      const idField = this.dayOfWeekDropdownSettings.idField;
      const filteredIds = new Set(items.map(item => item?.[idField]));
      const remaining = this.commonData.options.selectedDaysOfWeek.filter(
        (item: any) => !filteredIds.has(item?.[idField])
      );
      this.commonData.options.selectedDaysOfWeek = remaining;
      const ctrl = this.filtersForm.get("dayOfWeekDropdown");
      if (ctrl) ctrl.setValue(remaining);
    } else {
      this.commonData.options.selectedDaysOfWeek = [];
      const ctrl = this.filtersForm.get("dayOfWeekDropdown");
      if (ctrl) ctrl.setValue([]);
    }
    this.dirty = false;
    this.setApplyTooltipText(false, true);
    this.addCustomTemplate();
  }
  // Requested Users
  public userRequestedList: any[] = [];
  public selectedRequestedUsers: any[] = [];
  public userRequestedDropdownSettings = {
    singleSelection: false,
    idField: "code",
    textField: "localizedStaffFullname",
    itemsShowLimit: 3,
    unSelectAllText: this.translateService.instant(
      "_General_Unselect_All_Ts_Text_"
    ),
    selectAllText: this.translateService.instant("_General_Select_All_Text_"),
    noDataAvailablePlaceholderText: this.translateService.instant(
      "_Dashboard_No_Data_Available_Message_Text_"
    ),
    allowSearchFilter: true,
    enableCheckAll: true,
    closeDropDownOnSelection: false,
    searchPlaceholderText: this.translateService.instant(
      "_General_Search_Text_"
    ),
  };
  onRequestedUserSelect() {
    this.optionsDirty();
  }

  onRequestedUserDeSelect() {
    this.optionsDirty();
  }

  onSelectAllRequestedUsers(items?: any[]) {
    if (items && items.length > 0) {
      const merged = this.mergeSelectAllWithExisting(
        this.commonData.options.selectedRequestedStaff,
        items,
        this.userRequestedDropdownSettings.idField
      );
      this.commonData.options.selectedRequestedStaff = merged;
      const ctrl = this.filtersForm.get("userRequestedDropdown");
      if (ctrl) ctrl.setValue(merged);
      setTimeout(() => this.cdr.markForCheck(), 0);
    }
    this.optionsDirty("RequestedStaff");
  }

  onDeSelectAllRequestedUsers(items?: any[]) {
    const idField = this.userRequestedDropdownSettings.idField;
    const itemsToUnselect = this.resolveItemsToUnselect(
      items,
      this.pendingRequestedStaffUnSelectData,
      this.requestedStaffDropdownRef
    );

    if (itemsToUnselect.length === 0) {
      this.commonData.options.selectedRequestedStaff = [];
      const ctrl = this.filtersForm.get("userRequestedDropdown");
      if (ctrl) ctrl.setValue([]);
      this.pendingRequestedStaffUnSelectData = null;
      this.dirty = false;
      this.setApplyTooltipText(false, true);
      return;
    }
    
    const idsToUnselect = new Set(itemsToUnselect.map(item => item?.[idField]));
    const remaining = this.commonData.options.selectedRequestedStaff.filter(
      (item: any) => !idsToUnselect.has(item?.[idField])
    );
    this.commonData.options.selectedRequestedStaff = remaining;
    const ctrl = this.filtersForm.get("userRequestedDropdown");
    if (ctrl) ctrl.setValue(remaining);
    
    this.dirty = false;
    this.setApplyTooltipText(false, true);
    if (remaining && remaining.length > 0) {
      this.addCustomTemplate();
    }
    this.pendingRequestedStaffUnSelectData = null;
  }

  // Assisted By
  public assistedByList: any[] = [];
  public selectedAssistedBys: any[] = [];
  public assistedByDropdownSettings = {
    singleSelection: false,
    idField: "code",
    textField: "staffFullname",
    itemsShowLimit: 3,
    unSelectAllText: this.translateService.instant(
      "_General_Unselect_All_Ts_Text_"
    ),
    selectAllText: this.translateService.instant("_General_Select_All_Text_"),
    noDataAvailablePlaceholderText: this.translateService.instant(
      "_Dashboard_No_Data_Available_Message_Text_"
    ),
    allowSearchFilter: true,
    enableCheckAll: true,
    closeDropDownOnSelection: false,
    searchPlaceholderText: this.translateService.instant(
      "_General_Search_Text_"
    ),
  };
  onAssistedBySelect() {
    this.optionsDirty();
  }

  onAssistedByDeSelect() {
    this.optionsDirty();
  }

  onSelectAllAssistedBys(items?: any[]) {
    if (items && items.length > 0) {
      const merged = this.mergeSelectAllWithExisting(
        this.commonData.options.selectedAssistedBys,
        items,
        this.assistedByDropdownSettings.idField
      );
      this.commonData.options.selectedAssistedBys = merged;
      const ctrl = this.filtersForm.get("assistedByDropdown");
      if (ctrl) ctrl.setValue(merged);
      setTimeout(() => this.cdr.markForCheck(), 0);
    }
    this.optionsDirty("AssistedBy");
  }

  onDeSelectAllAssistedBys(items?: any[]) {
    const idField = this.assistedByDropdownSettings.idField;
    const itemsToUnselect = this.resolveItemsToUnselect(
      items,
      this.pendingAssistedByUnSelectData,
      this.assistedByDropdownRef
    );

    if (itemsToUnselect.length === 0) {
      this.commonData.options.selectedAssistedBys = [];
      const ctrl = this.filtersForm.get("assistedByDropdown");
      if (ctrl) ctrl.setValue([]);
      this.pendingAssistedByUnSelectData = null;
      this.dirty = false;
      this.setApplyTooltipText(false, true);
      return;
    }
    
    const idsToUnselect = new Set(itemsToUnselect.map(item => item?.[idField]));
    const remaining = this.commonData.options.selectedAssistedBys.filter(
      (item: any) => !idsToUnselect.has(item?.[idField])
    );
    this.commonData.options.selectedAssistedBys = remaining;
    const ctrl = this.filtersForm.get("assistedByDropdown");
    if (ctrl) ctrl.setValue(remaining);
    
    this.dirty = false;
    this.setApplyTooltipText(false, true);
    if (remaining && remaining.length > 0) {
      this.addCustomTemplate();
    }
    this.pendingAssistedByUnSelectData = null;
  }

  // Supervisors
  public supervisorList: any[] = [];
  public selectedSupervisors: any[] = [];
  public supervisorDropdownSettings = {
    singleSelection: false,
    idField: "code",
    textField: "localizedStaffFullname",
    itemsShowLimit: 3,
    unSelectAllText: this.translateService.instant(
      "_General_Unselect_All_Ts_Text_"
    ),
    selectAllText: this.translateService.instant("_General_Select_All_Text_"),
    noDataAvailablePlaceholderText: this.translateService.instant(
      "_Dashboard_No_Data_Available_Message_Text_"
    ),
    allowSearchFilter: true,
    enableCheckAll: true,
    closeDropDownOnSelection: false,
    searchPlaceholderText: this.translateService.instant(
      "_General_Search_Text_"
    ),
  };

  onSupervisorSelect(item?: any) {
    if (this.supervisorClearAllArmed) {
      const idField = this.supervisorDropdownSettings.idField;
      const selectedSupervisors = this.commonData.options.selectedSupervisors || [];
      const selectedItem =
        item?.[idField] != null
          ? selectedSupervisors.find(
              (supervisor: any) => supervisor?.[idField] === item?.[idField]
            ) || item
          : item;
      this.supervisorSelectionAfterClear = selectedItem ? [selectedItem] : [];
      this.supervisorSingleSelectAfterClearAt = Date.now();
    }
    this.commonData.filterAssistedByStaffBySupervisor();
    this.addCustomTemplate();
    this.enableDefaultCheckboxes(true);
  }

  onSupervisorDeSelect() {
    this.commonData.filterAssistedByStaffBySupervisor();
    this.addCustomTemplate();
    this.filtersForm.markAsTouched();
  }

  onSelectAllSupervisors(items?: any[]) {
    if (items && items.length > 0) {
      const selectedSupervisors = this.commonData.options.selectedSupervisors || [];
      const filteredSupervisors =
        this.supervisorDropdownRef?.data || this.commonData.options.supervisors || [];
      const isFullFilteredSet = items.length === filteredSupervisors.length;
      const selectedCount = selectedSupervisors.length;
      const allSelectedFlag = !!(this.supervisorDropdownRef as any)?._allSelected;
      const singleSelectAfterClearJustHappened =
        this.supervisorClearAllArmed &&
        this.supervisorSelectionAfterClear.length === 1 &&
        Date.now() - this.supervisorSingleSelectAfterClearAt < 1200;

      if (isFullFilteredSet && singleSelectAfterClearJustHappened) {
        this.commonData.options.selectedSupervisors = [
          ...this.supervisorSelectionAfterClear,
        ];
        const ctrl = this.filtersForm.get("supervisorDropdown");
        if (ctrl) ctrl.setValue(this.commonData.options.selectedSupervisors);
        this.supervisorClearAllArmed = false;
        this.supervisorSelectionAfterClear = [];
        this.supervisorSingleSelectAfterClearAt = 0;
        return;
      }

      if (
        isFullFilteredSet &&
        !allSelectedFlag &&
        selectedCount > 0 &&
        selectedCount < items.length
      ) {
        return;
      }

      const merged = this.mergeSelectAllWithExisting(
        selectedSupervisors,
        items,
        this.supervisorDropdownSettings.idField
      );
      this.commonData.options.selectedSupervisors = merged;
      const ctrl = this.filtersForm.get("supervisorDropdown");
      if (ctrl) ctrl.setValue(merged);
      this.supervisorClearAllArmed = false;
      this.supervisorSelectionAfterClear = [];
      this.supervisorSingleSelectAfterClearAt = 0;
    }
    this.optionsDirty("Supervisors");
    this.commonData.filterAssistedByStaffBySupervisor(items, true);
  }

  onDeSelectAllSupervisors(items: any) {
    const idField = this.supervisorDropdownSettings.idField;
    const itemsToUnselect = this.resolveItemsToUnselect(
      items,
      this.pendingSupervisorUnSelectData,
      this.supervisorDropdownRef
    );

    if (itemsToUnselect.length === 0) {
      this.commonData.options.selectedSupervisors = [];
      const ctrl = this.filtersForm.get("supervisorDropdown");
      if (ctrl) ctrl.setValue([]);
      this.supervisorClearAllArmed = true;
      this.supervisorSelectionAfterClear = [];
      this.supervisorSingleSelectAfterClearAt = 0;
      this.pendingSupervisorUnSelectData = null;
      this.commonData.filterAssistedByStaffBySupervisor(items);
      this.dirty = false;
      this.setApplyTooltipText(false, true);
      this.enableDefaultCheckboxes(true);
      return;
    }
    
    const idsToUnselect = new Set(itemsToUnselect.map(item => item?.[idField]));
    const remaining = this.commonData.options.selectedSupervisors.filter(
      (item: any) => !idsToUnselect.has(item?.[idField])
    );
    this.commonData.options.selectedSupervisors = remaining;
    const ctrl = this.filtersForm.get("supervisorDropdown");
    if (ctrl) ctrl.setValue(remaining);
    this.supervisorClearAllArmed = remaining.length === 0;
    this.supervisorSelectionAfterClear = [];
    this.supervisorSingleSelectAfterClearAt = 0;
    
    this.commonData.filterAssistedByStaffBySupervisor(items);
    this.dirty = false;
    this.setApplyTooltipText(false, true);
    this.enableDefaultCheckboxes(true);
    if (remaining && remaining.length > 0) {
      this.addCustomTemplate();
    }
    this.pendingSupervisorUnSelectData = null;
  }

  // Categories
  public categoryList: any[] = [];
  public selectedCategories: any[] = [];
  public categoryDropdownSettings = {
    singleSelection: false,
    idField: "code",
    textField: "categoryName",
    itemsShowLimit: 3,
    unSelectAllText: this.translateService.instant(
      "_General_Unselect_All_Ts_Text_"
    ),
    selectAllText: this.translateService.instant("_General_Select_All_Text_"),
    noDataAvailablePlaceholderText: this.translateService.instant(
      "_Dashboard_No_Data_Available_Message_Text_"
    ),
    allowSearchFilter: true,
    enableCheckAll: true,
    closeDropDownOnSelection: false,
    searchPlaceholderText: this.translateService.instant(
      "_General_Search_Text_"
    ),
  };
  onCategorySelect() {
    this.commonData.filterServicesByCategory();
    this.addCustomTemplate();
    this.enableDefaultCheckboxes(true);
  }

  onCategoryDeSelect() {
    this.filtersForm.markAsTouched();
    this.commonData.filterServicesByCategory();
    this.addCustomTemplate();
    this.filtersForm.markAsTouched();
  }

  onSelectAllCategories(items?: any[]) {
    if (items && items.length > 0) {
      const merged = this.mergeSelectAllWithExisting(
        this.commonData.options.selectedCategories,
        items,
        this.categoryDropdownSettings.idField
      );
      this.commonData.options.selectedCategories = merged;
      const ctrl = this.filtersForm.get("categoryDropdown");
      if (ctrl) ctrl.setValue(merged);
      setTimeout(() => this.cdr.markForCheck(), 0);
    }
    this.optionsDirty("Categories");
    this.commonData.filterServicesByCategory(items);
  }

  onDeSelectAllCategories(items: any) {
    const idField = this.categoryDropdownSettings.idField;
    const itemsToUnselect = this.resolveItemsToUnselect(
      items,
      this.pendingCategoryUnSelectData,
      this.categoryDropdownRef
    );

    if (itemsToUnselect.length === 0) {
      this.commonData.options.selectedCategories = [];
      const ctrl = this.filtersForm.get("categoryDropdown");
      if (ctrl) ctrl.setValue([]);
      this.pendingCategoryUnSelectData = null;
      this.commonData.filterServicesByCategory(items);
      this.dirty = false;
      this.setApplyTooltipText(false, true);
      this.enableDefaultCheckboxes(true);
      return;
    }
    
    const idsToUnselect = new Set(itemsToUnselect.map(item => item?.[idField]));
    const remaining = this.commonData.options.selectedCategories.filter(
      (item: any) => !idsToUnselect.has(item?.[idField])
    );
    this.commonData.options.selectedCategories = remaining;
    const ctrl = this.filtersForm.get("categoryDropdown");
    if (ctrl) ctrl.setValue(remaining);
    
    this.commonData.filterServicesByCategory(items);
    this.dirty = false;
    this.setApplyTooltipText(false, true);
    this.enableDefaultCheckboxes(true);
    if (remaining && remaining.length > 0) {
      this.addCustomTemplate();
    }
    this.pendingCategoryUnSelectData = null;
  }
  // Services
  public serviceList: any[] = [];
  public selectedServices: any[] = [];
  public serviceDropdownSettings = {
    singleSelection: false,
    idField: "code",
    textField: "serviceName",
    itemsShowLimit: 3,
    unSelectAllText: this.translateService.instant(
      "_General_Unselect_All_Ts_Text_"
    ),
    selectAllText: this.translateService.instant("_General_Select_All_Text_"),
    noDataAvailablePlaceholderText: this.translateService.instant(
      "_Dashboard_No_Data_Available_Message_Text_"
    ),
    allowSearchFilter: true,
    enableCheckAll: true,
    closeDropDownOnSelection: false,
    searchPlaceholderText: this.translateService.instant(
      "_General_Search_Text_"
    ),
  };
  onServiceSelect(item?: any) {
    const idField = this.serviceDropdownSettings.idField;
    this.lastServiceSingleSelectAt = Date.now();
    this.lastServiceSingleSelectId = item?.[idField] ?? null;

    if (this.serviceClearAllArmed) {
      const selectedServices = this.commonData.options.selectedServices || [];
      const selectedItem =
        this.lastServiceSingleSelectId != null
          ? selectedServices.find(
              (service: any) => service?.[idField] === this.lastServiceSingleSelectId
            ) || item
          : item;

      this.serviceSelectionAfterClear = selectedItem ? [selectedItem] : [];
      this.serviceSingleSelectAfterClearAt = Date.now();
    }

    setTimeout(() => this.optionsDirty("", true, true), 0);
  }

  onServiceDeSelect() {
    setTimeout(() => this.optionsDirty("", true, true), 0);
  }

  onSelectAllServices(items?: any[]) {
    // Trust the dropdown's bound ngModel state for services selection.
    // Payload-driven writes here caused phantom full-selection and dropdown collapse.
    this.serviceClearAllArmed = false;
    this.serviceSelectionAfterClear = [];
    this.serviceSingleSelectAfterClearAt = 0;
    setTimeout(() => this.optionsDirty("Services", true, true), 0);
  }

  onDeSelectAllServices(items?: any[]) {
    const idField = this.serviceDropdownSettings.idField;
    const itemsToUnselect = this.resolveItemsToUnselect(
      items,
      this.pendingServiceUnSelectData,
      this.serviceDropdownRef
    );

    if (itemsToUnselect.length === 0) {
      this.commonData.options.selectedServices = [];
      const ctrl = this.filtersForm.get("serviceDropdown");
      if (ctrl) ctrl.setValue([]);
      this.serviceClearAllArmed = true;
      this.serviceSelectionAfterClear = [];
      this.serviceSingleSelectAfterClearAt = 0;
      this.lastServiceSingleSelectId = null;
      if (this.serviceDropdownRef) {
        if ((this.serviceDropdownRef as any)._allSelected !== undefined) {
          (this.serviceDropdownRef as any)._allSelected = false;
        }
        if ((this.serviceDropdownRef as any).updateSelectedItems) {
          (this.serviceDropdownRef as any).updateSelectedItems();
        }
        if ((this.serviceDropdownRef as any).updateCheckboxLabel) {
          (this.serviceDropdownRef as any).updateCheckboxLabel();
        }
      }
      this.pendingServiceUnSelectData = null;
      this.dirty = false;
      this.setApplyTooltipText(false, true);
      return;
    }
    
    const idsToUnselect = new Set(itemsToUnselect.map(item => item?.[idField]));
    const remaining = this.commonData.options.selectedServices.filter(
      (item: any) => !idsToUnselect.has(item?.[idField])
    );
    this.commonData.options.selectedServices = remaining;
    const ctrl = this.filtersForm.get("serviceDropdown");
    if (ctrl) ctrl.setValue(remaining);
    this.serviceClearAllArmed = remaining.length === 0;
    this.serviceSelectionAfterClear = [];
    this.serviceSingleSelectAfterClearAt = 0;
    if (remaining.length === 0) {
      this.lastServiceSingleSelectId = null;
    }
    if (this.serviceDropdownRef) {
      if ((this.serviceDropdownRef as any)._allSelected !== undefined) {
        (this.serviceDropdownRef as any)._allSelected = false;
      }
      if ((this.serviceDropdownRef as any).updateSelectedItems) {
        (this.serviceDropdownRef as any).updateSelectedItems();
      }
      if ((this.serviceDropdownRef as any).updateCheckboxLabel) {
        (this.serviceDropdownRef as any).updateCheckboxLabel();
      }
    }
    
    this.dirty = false;
    this.setApplyTooltipText(false, true);
    if (remaining && remaining.length > 0) {
      this.addCustomTemplate();
    }
    this.pendingServiceUnSelectData = null;
  }
  // Status
  public statusList: any[] = [];
  public selectedStatuses: any[] = [];
  public statusDropdownSettings = {
    singleSelection: false,
    idField: "lobbyStatusId",
    textField: "localizedStatusName",
    itemsShowLimit: 3,
    unSelectAllText: this.translateService.instant(
      "_General_Unselect_All_Ts_Text_"
    ),
    selectAllText: this.translateService.instant("_General_Select_All_Text_"),
    noDataAvailablePlaceholderText: this.translateService.instant(
      "_Dashboard_No_Data_Available_Message_Text_"
    ),
  };
  onStatusSelect() {
    this.optionsDirty();
  }

  onStatusDeSelect() {
    this.optionsDirty();
  }

  onSelectAllStatuses(items?: any[]) {
    if (items && items.length > 0) {
      const merged = this.mergeSelectAllWithExisting(
        this.commonData.options.selectedStatuses,
        items,
        this.statusDropdownSettings.idField
      );
      this.commonData.options.selectedStatuses = merged;
      const ctrl = this.filtersForm.get("statusDropdown");
      if (ctrl) ctrl.setValue(merged);
      setTimeout(() => this.cdr.markForCheck(), 0);
    }
    this.optionsDirty("Statuses");
  }

  onDeSelectAllStatuses(items?: any[]) {
    if (items && items.length > 0) {
      const idField = this.statusDropdownSettings.idField;
      const filteredIds = new Set(items.map(item => item?.[idField]));
      const remaining = this.commonData.options.selectedStatuses.filter(
        (item: any) => !filteredIds.has(item?.[idField])
      );
      this.commonData.options.selectedStatuses = remaining;
      const ctrl = this.filtersForm.get("statusDropdown");
      if (ctrl) ctrl.setValue(remaining);
    } else {
      this.commonData.options.selectedStatuses = [];
      const ctrl = this.filtersForm.get("statusDropdown");
      if (ctrl) ctrl.setValue([]);
    }
    this.dirty = false;
    this.setApplyTooltipText(false, true);
    this.addCustomTemplate();
  }
  // Assist types
  public assistTypeList = [];
  public selectedAssistTypes: any[] = [];
  public assistTypeDropdownSettings = {
    singleSelection: false,
    idField: "assistTypeId",
    textField: "localizedAssistTypeName",
    itemsShowLimit: 3,
    unSelectAllText: this.translateService.instant(
      "_General_Unselect_All_Ts_Text_"
    ),
    selectAllText: this.translateService.instant("_General_Select_All_Text_"),
    noDataAvailablePlaceholderText: this.translateService.instant(
      "_Dashboard_No_Data_Available_Message_Text_"
    ),
  };
  onAssistTypeSelect() {
    this.optionsDirty();
  }

  onAssistTypeDeSelect() {
    this.optionsDirty();
  }

  onSelectAllAssistTypes(items?: any[]) {
    if (items && items.length > 0) {
      const merged = this.mergeSelectAllWithExisting(
        this.commonData.options.selectedAssistTypes,
        items,
        this.assistTypeDropdownSettings.idField
      );
      this.commonData.options.selectedAssistTypes = merged;
      const ctrl = this.filtersForm.get("assistTypeDropdown");
      if (ctrl) ctrl.setValue(merged);
    }
    this.optionsDirty("AssistTypes");
  }

  onDeSelectAllAssistTypes(items?: any[]) {
    if (items && items.length > 0) {
      const idField = this.assistTypeDropdownSettings.idField;
      const filteredIds = new Set(items.map(item => item?.[idField]));
      const remaining = this.commonData.options.selectedAssistTypes.filter(
        (item: any) => !filteredIds.has(item?.[idField])
      );
      this.commonData.options.selectedAssistTypes = remaining;
      const ctrl = this.filtersForm.get("assistTypeDropdown");
      if (ctrl) ctrl.setValue(remaining);
    } else {
      this.commonData.options.selectedAssistTypes = [];
      const ctrl = this.filtersForm.get("assistTypeDropdown");
      if (ctrl) ctrl.setValue([]);
    }
    this.dirty = false;
    this.setApplyTooltipText(false, true);
    this.addCustomTemplate();
  }
  // Views
  public viewList = [];
  public selectedViews: any[] = [];
  public viewDropdownSettings = {
    singleSelection: true,
    idField: "viewId",
    textField: "viewLocalizedName",
    noDataAvailablePlaceholderText: this.translateService.instant(
      "_Dashboard_No_Data_Available_Message_Text_"
    ),
  };
  onViewSelect() {
    this.optionsDirty();
  }

  onViewDeSelect() {
    this.optionsDirty();
  }

  // Auto-Wrap Up Records
  public autoWrapUpStatusList = [];
  public selectedAutoWrapUpStatus: [] = [];
  public autoWrapUpStatusDropdownSettings = {
    singleSelection: true,
    idField: "autoWrapUpStatusId",
    textField: "localizedAutoWrapUpStatus",
    noDataAvailablePlaceholderText: this.translateService.instant(
      "_Dashboard_No_Data_Available_Message_Text_"
    ),
  };
  onAutoWrapUpStatusSelect(item: any) {
    const aw = this.commonData.options.selectedAutoWrapUpStatus;
    this.commonData.options.selectedAutoWrapUpStatus = Array.isArray(aw)
      ? aw
      : aw
      ? [aw]
      : [];
    this.optionsDirty();
  }
  onAutoWrapUpStatusDeSelect(item: any) {
    const aw = this.commonData.options.selectedAutoWrapUpStatus;
    this.commonData.options.selectedAutoWrapUpStatus = Array.isArray(aw)
      ? aw
      : aw
      ? [aw]
      : [];
    this.optionsDirty();
  }

  // Signed-In Users
  public userList: any[] = [];
  public selectedUsers: any[] = [];
  private allSignInOutUsers: any[] = [];
  public debugMasterUnionUsers: any[] = [];
  public usersDropdownSettings = {
    singleSelection: false,
    idField: "code",
    textField: "staffFullname",
    itemsShowLimit: 3,
    unSelectAllText: this.translateService.instant(
      "_General_Unselect_All_Ts_Text_"
    ),
    selectAllText: this.translateService.instant("_General_Select_All_Text_"),
    noDataAvailablePlaceholderText: this.translateService.instant(
      "_Dashboard_No_Data_Available_Message_Text_"
    ),
    allowSearchFilter: true,
    enableCheckAll: true,
    closeDropDownOnSelection: false,
    searchPlaceholderText: this.translateService.instant(
      "_General_Search_Text_"
    ),
  };
  onUsersSelect() {
    this.optionsDirty();
  }

  onUsersDeSelect() {
    this.optionsDirty();
  }

  onSelectAllUsers(items?: any[]) {
    if (items && items.length > 0) {
      const merged = this.mergeSelectAllWithExisting(
        this.commonData.options.selectedUsers,
        items,
        this.usersDropdownSettings.idField
      );
      this.commonData.options.selectedUsers = merged;
      const ctrl = this.filtersForm.get("signedInUsersDropdown");
      if (ctrl) ctrl.setValue(merged);
      setTimeout(() => this.cdr.markForCheck(), 0);
    }
    this.optionsDirty("Users");
  }

  onDeSelectAllUsers(items?: any[]) {
    const idField = this.usersDropdownSettings.idField;
    const itemsToUnselect = this.resolveItemsToUnselect(
      items,
      this.pendingUserUnSelectData,
      this.usersDropdownRef
    );

    if (itemsToUnselect.length === 0) {
      this.commonData.options.selectedUsers = [];
      const ctrl = this.filtersForm.get("signedInUsersDropdown");
      if (ctrl) ctrl.setValue([]);
      this.pendingUserUnSelectData = null;
      this.dirty = false;
      this.setApplyTooltipText(false, true);
      return;
    }
    
    const idsToUnselect = new Set(itemsToUnselect.map(item => item?.[idField]));
    const remaining = this.commonData.options.selectedUsers.filter(
      (item: any) => !idsToUnselect.has(item?.[idField])
    );
    this.commonData.options.selectedUsers = remaining;
    const ctrl = this.filtersForm.get("signedInUsersDropdown");
    if (ctrl) ctrl.setValue(remaining);
    
    this.dirty = false;
    this.setApplyTooltipText(false, true);
    if (remaining && remaining.length > 0) {
      this.addCustomTemplate();
    }
    this.pendingUserUnSelectData = null;
  }

  private updateSignInOutUsersForLocations(): void {
    const selectedLocations = this.commonData.options.selectedLocations || [];
    const allLocations = this.commonData.options.locations || [];

    if (!this.allSignInOutUsers.length && this.commonData.options.users && this.commonData.options.users.length) {
      this.allSignInOutUsers = [...this.commonData.options.users];
    }

    if (!selectedLocations || selectedLocations.length === 0) {
      this.commonData.options.users = [];
      this.commonData.options.selectedUsers = [];
      const signedCtrl = this.filtersForm.get("signedInUsersDropdown");
      if (signedCtrl) {
        signedCtrl.setValue([]);
        signedCtrl.updateValueAndValidity();
      }
      this.cdr.markForCheck();
      this.cdr.detectChanges();
      return;
    }

    const normalizeKey = (x: any) =>
      x == null
        ? null
        : (x.code ?? x.locationCode ?? x.locationId ?? x.id ?? x).toString();

    const isAllSelected =
      selectedLocations.length &&
      allLocations.length &&
      allLocations.every((l: any) =>
        selectedLocations.some((sl: any) => normalizeKey(sl) === normalizeKey(l))
      );

    if (isAllSelected) {
      
      if (this.allSignInOutUsers.length > 0) {
        this.commonData.options.users = [...this.allSignInOutUsers];
        this.commonData.options.selectedUsers = [...this.allSignInOutUsers];
        const signedCtrl = this.filtersForm.get("signedInUsersDropdown");
        if (signedCtrl) {
          signedCtrl.setValue(this.commonData.options.selectedUsers);
          signedCtrl.markAsDirty();
          signedCtrl.updateValueAndValidity();
        }
        this.cdr.markForCheck();
        this.cdr.detectChanges();
        return;
      }
      
      this.userService.getUsersByLocation(0).subscribe({
        next: (allUsers: any[]) => {
          if (!allUsers || !Array.isArray(allUsers)) {
            console.error("[Filters] Invalid users data received:", allUsers);
            return;
          }
          
          const formattedUsers = allUsers.map(user => ({
            code: user.code || user.id?.toString(),
            staffId: user.id,
            staffFullname: `${user.firstName || ''} ${user.lastName || ''}`.trim(),
            localizedStaffFullname:
              user.localizedStaffFullname ||
              user.staffFullname ||
              `${user.firstName || ''} ${user.lastName || ''}`.trim(),
            locationCode: user.locationCode || ''
          }));
          
          this.allSignInOutUsers = [...formattedUsers];
          this.commonData.options.users = [...formattedUsers];
          this.commonData.options.selectedUsers = [...formattedUsers];
          const signedCtrl = this.filtersForm.get("signedInUsersDropdown");
          if (signedCtrl) {
            signedCtrl.setValue(this.commonData.options.selectedUsers);
            signedCtrl.markAsDirty();
            signedCtrl.updateValueAndValidity();
          }
          this.cdr.markForCheck();
          this.cdr.detectChanges();
          
        },
        error: (error) => {
          console.error("[Filters] Error fetching all users:", error);
          if (this.allSignInOutUsers.length > 0) {
            this.commonData.options.users = [...this.allSignInOutUsers];
            this.commonData.options.selectedUsers = [...this.allSignInOutUsers];
            const signedCtrl = this.filtersForm.get("signedInUsersDropdown");
            if (signedCtrl) {
              signedCtrl.setValue(this.commonData.options.selectedUsers);
              signedCtrl.updateValueAndValidity();
            }
            this.cdr.markForCheck();
            this.cdr.detectChanges();
          }
        }
      });
      return;
    }

    const locationIds: number[] = [];
    const allLocs = this.commonData.options.locations || [];
    const normalizeLocId = (obj: any): number | null => {
      if (!obj) return null;
      if (typeof obj.locationId === "number" && obj.locationId > 0) return obj.locationId;
      if (typeof obj.id === "number" && obj.id > 0) return obj.id;
      const key = obj.code ?? obj.locationCode ?? obj.locationId ?? obj.id ?? null;
      if (key == null) return null;
      const found = allLocs.find((l: any) => {
        const lk = l.code ?? l.locationCode ?? l.locationId ?? l.id ?? null;
        return lk != null && lk.toString() === key.toString();
      });
      return found && typeof found.locationId === "number" ? found.locationId : null;
    };

    selectedLocations.forEach((sl: any) => {
      const id = normalizeLocId(sl);
      if (id && !locationIds.includes(id)) locationIds.push(id);
    });

    if (!locationIds.length) {
      this.commonData.options.users = [];
      this.commonData.options.selectedUsers = [];
      return;
    }

    if (!this.allSignInOutUsers.length && this.commonData.options.users?.length) {
      this.allSignInOutUsers = [...this.commonData.options.users];
    }

    const baseUsers = this.allSignInOutUsers.length
      ? this.allSignInOutUsers
      : (this.commonData.options.users || []);

    const requests = locationIds.map((id: number) => this.userService.getUsersByLocation(id));

    forkJoin(requests).subscribe(
      (responses: any[][]) => {
        try {
          responses.forEach((r, idx) => {
            if (r && r.length > 0) {
            } else {
            }
          });
        } catch(e) {  }

        const flattened: any[] = ([] as any[]).concat(...responses);

        try {
          const masterUnion = new Map<string, any>();
          flattened.forEach((u: any) => {
            if (!u) return;
            const key = (u.code ?? u.staffCode ?? u.id ?? u.staffId ?? u.staffFullname ?? u.fullName ?? u.name ?? (u.firstName && u.lastName ? `${u.firstName}.${u.lastName}` : null));
            if (!key) return;
            const k = key.toString();
            if (!masterUnion.has(k)) {
              masterUnion.set(k, {
                code: u.code ?? (u.staffCode ?? (u.id ? u.id.toString() : undefined)),
                staffId: u.id ?? u.staffId ?? null,
                staffFullname: u.staffFullname ?? u.fullName ?? u.name ?? `${u.firstName ?? ''} ${u.lastName ?? ''}`.trim(),
                localizedStaffFullname:
                  u.localizedStaffFullname ??
                  u.staffFullname ??
                  u.fullName ??
                  u.name ??
                  `${u.firstName ?? ''} ${u.lastName ?? ''}`.trim(),
              });
            }
          });
          const masterArr = Array.from(masterUnion.values());
          this.debugMasterUnionUsers = masterArr;
          const masterSample = masterArr.slice(0, 200).map((x: any) => ({ id: x.staffId ?? x.code, name: x.staffFullname }));
        } catch (e) {
        }

        try {
          const masterUnion = this.debugMasterUnionUsers && this.debugMasterUnionUsers.length ? this.debugMasterUnionUsers : [];
          const unionCodeSet = new Set<string>();
          const unionIdSet = new Set<string>();
          masterUnion.forEach((u: any) => {
            if (!u) return;
            if (u.code) unionCodeSet.add(u.code.toString());
            if (u.staffId != null) unionIdSet.add(u.staffId.toString());
          });

          let finalUsers: any[] = [];
          if (baseUsers && baseUsers.length) {
            const matched = baseUsers.filter((b: any) => {
              const bCode = (b.code ?? b.staffCode ?? b.code) as any;
              const bId = (b.staffId ?? b.id ?? null) as any;
              if (bCode && unionCodeSet.has(bCode.toString())) return true;
              if (bId != null && unionIdSet.has(bId.toString())) return true;
              const bName = (b.localizedStaffFullname ?? b.staffFullname ?? b.fullName ?? b.name) as any;
              if (bName) {
                const lower = bName.toString().trim().toLowerCase();
                return masterUnion.some((mu: any) => (mu.staffFullname || '').toString().trim().toLowerCase() === lower);
              }
              return false;
            });
            finalUsers = matched.length ? matched : masterUnion;
          } else {
            finalUsers = masterUnion;
          }

          this.commonData.options.users = finalUsers.map((user: any) => ({
            ...user,
            localizedStaffFullname:
              user.localizedStaffFullname ||
              user.staffFullname ||
              user.fullName ||
              user.name ||
              "",
          }));
          this.commonData.options.selectedUsers = [...finalUsers];
          const signedCtrl = this.filtersForm.get("signedInUsersDropdown");
          if (signedCtrl) {
            signedCtrl.setValue(this.commonData.options.selectedUsers);
            signedCtrl.markAsDirty();
            signedCtrl.updateValueAndValidity();
          }
          this.cdr.markForCheck();
          this.cdr.detectChanges();
        } catch (e) {
          this.commonData.options.users = [];
          this.commonData.options.selectedUsers = [];
          const signedCtrl = this.filtersForm.get("signedInUsersDropdown");
          if (signedCtrl) signedCtrl.setValue([]);
          this.cdr.markForCheck();
          this.cdr.detectChanges();
        }
      },
      () => {
        console.warn("[Filters] Error while fetching users by location. Clearing SignIn/Out users list.");
        this.commonData.options.users = [];
        this.commonData.options.selectedUsers = [];
        const signedCtrl = this.filtersForm.get("signedInUsersDropdown");
        if (signedCtrl) signedCtrl.setValue([]);
        this.cdr.markForCheck();
        this.cdr.detectChanges();
      }
    );
  }


  //#endregion Filter Options Configuration

  // Search term
  // public searchChanged(evt) {
  //   this.optionsDirty();
  // }
  public setApplyTooltipText(
    changeRequired: boolean,
    selectionRequired: boolean
  ) {
    if (changeRequired) {
      this.applyTooltipText = this.translateService.instant(
        "_Report_Make_One_Change_Ts_Text_"
      );
    } else if (selectionRequired) {
      this.applyTooltipText = this.translateService.instant(
        "_Report_Make_Selection_Ts_Text_"
      );
    } else {
      this.applyTooltipText = "";
    }
  }
  public editingTemplateChanged(e: any) {
    const s = this.filtersForm.get("editListDropdown")?.value;
    this.commonData.SetActiveTemplate(s);
    this.originalTemplateIsDefault = this.commonData.currentTemplate.isDefault;
    this.commonData.ConvertCurrentTemplateToOptions(this.detailViewId);

    var sharedOptions = this.commonData.mapSharedOptionData();
    this.sharedUsers = sharedOptions.users;
    this.sharedPermissionGroups = sharedOptions.groups;
    this.orginalTemplateName = this.commonData.currentTemplate.templateName;

    this.commonData.options.filteredServices = this.commonData.currentTemplate
      .allServices
      ? this.commonData.options.services
      : this.commonData.currentTemplate.activeFilters.services;
    this.commonData.options.filteredAssistedBys = this.commonData
      .currentTemplate.allAssistedBy
      ? this.commonData.options.assistedBy
      : this.commonData.currentTemplate.activeFilters.assistedBy;
    this.commonData.filterServicesByCategory(
      this.commonData.options.selectedCategories
    );
    this.commonData.EnrichSelectedOptions();
    this.setFormSelectionsFromOptions();
    this.commonData.trafficAndWaitViewDataLoaded = false;
    this.commonData.locationComparisonViewDataLoaded = false;
    this.commonData.productsAndServicesViewDataLoaded = false;
    this.commonData.employeeViewDataLoaded = false;
    this.commonData.headerDataLoaded = false;
    var match = this.commonData.TemplateMatchesExisting(
      this.commonData.currentTemplate,
      true,
      this.commonData.originalTemplates
    );

    this.dirty = match ? false : true;
    this.formValid = true;
    this.differentTemplateThanEntry =
      s != this.entryTemplateName ? true : false;
    this.enableDefaultCheckboxes(s != "None");

    if (s != "Custom") {
      this.filtersForm.markAsPristine();
      this.filtersForm.markAsUntouched();
    }
  }
  public templateDropdownOnBlur() {
    this.filtersForm.controls["editListDropdown"].markAsPristine();
    this.filtersForm.controls["editListDropdown"].markAsUntouched();
  }
  private setFormSelectionsFromOptions(): void {
    const setArrayControl = (controlName: string, value: any[]) => {
      const ctrl = this.filtersForm.get(controlName);
      if (ctrl) {
        ctrl.setValue(value ? [...value] : []);
      }
    };

    setArrayControl("locationDropdown", this.commonData.options.selectedLocations);
    setArrayControl("timePeriodDropdown", this.commonData.options.selectedTimePeriod);
    setArrayControl("dayOfWeekDropdown", this.commonData.options.selectedDaysOfWeek);
    setArrayControl("userRequestedDropdown", this.commonData.options.selectedRequestedStaff);
    setArrayControl("assistedByDropdown", this.commonData.options.selectedAssistedBys);
    setArrayControl("supervisorDropdown", this.commonData.options.selectedSupervisors);
    setArrayControl("categoryDropdown", this.commonData.options.selectedCategories);
    setArrayControl("serviceDropdown", this.commonData.options.selectedServices);
    setArrayControl("statusDropdown", this.commonData.options.selectedStatuses);
    setArrayControl("assistTypeDropdown", this.commonData.options.selectedAssistTypes);
    setArrayControl("viewDropdown", this.commonData.options.selectedViews);
    setArrayControl(
      "autoWrapUpStatusDropdown",
      this.commonData.options.selectedAutoWrapUpStatus
    );
    setArrayControl("signedInUsersDropdown", this.commonData.options.selectedUsers);

    const searchCtrl = this.filtersForm.get("search");
    if (searchCtrl) {
      const firstSearch =
        this.commonData.options.searchTerms &&
        this.commonData.options.searchTerms.length > 0
          ? this.commonData.options.searchTerms[0].searchTerm
          : "";
      searchCtrl.setValue(firstSearch);
    }

    const defaultCtrl = this.filtersForm.get("isDefault");
    if (defaultCtrl) {
      defaultCtrl.setValue(this.commonData.currentTemplate.isDefault);
    }
  }
  public setActiveTemplateOnUI(s: string) {
    this.filtersForm.get("editListDropdown")?.setValue(s);

    this.editingTemplateChanged(null);
  }
  public enableDefaultCheckboxes(enabled?: boolean) {
    enabled =
      enabled ??
      !(
        this.commonData.currentTemplate.templateName == "None" &&
        this.filtersForm.untouched
      );
    if (enabled) {
      this.filtersForm.get("isDefault")?.enable({ onlySelf: true });
    } else {
      this.filtersForm.get("isDefault")?.disable({ onlySelf: true });
    }
  }

  private restoreUserLists(): void {
    try {
      const selectedLocations = this.commonData.options.selectedLocations || [];
      
      if (!selectedLocations.length) {
        this.commonData.options.users = [];
        this.commonData.options.selectedUsers = [];
        this.commonData.options.requestedStaff = [];
        const signedCtrl = this.filtersForm.get("signedInUsersDropdown");
        if (signedCtrl) signedCtrl.setValue([]);
        return;
      }
      
      if (this.allSignInOutUsers && this.allSignInOutUsers.length > 0) {
        this.commonData.options.users = [...this.allSignInOutUsers];
        this.commonData.options.requestedStaff = [...this.allSignInOutUsers];
      } else if (this.commonData.options.users && this.commonData.options.users.length > 0) {
        this.commonData.options.users = [...this.commonData.options.users];
      } else {
        this.commonData.options.users = [];
        this.commonData.options.requestedStaff = [];
      }
      this.commonData.options.selectedUsers = [];
      const signedCtrl = this.filtersForm.get("signedInUsersDropdown");
      if (signedCtrl) signedCtrl.setValue(this.commonData.options.selectedUsers || []);
    } catch (e) {
    }
  }
}
